import { useOutletContext, useNavigate, useLocation } from "react-router-dom";
import React, { useState, useEffect, useCallback, useRef } from 'react';
import {
    Container,
    Row,
    Col,
    Form,
    Button,
    Tabs,
    Tab,
    Table,
    InputGroup,
    FormControl,
    OverlayTrigger,
    Tooltip,
    Spinner,
    Nav,
    Card
} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSignInAlt } from '@fortawesome/free-solid-svg-icons'
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'
import { faFileExcel } from '@fortawesome/free-solid-svg-icons'
import { faSortDown } from '@fortawesome/free-solid-svg-icons'
import { faSortUp } from '@fortawesome/free-solid-svg-icons'
import { faSort } from '@fortawesome/free-solid-svg-icons'
import { faGear } from '@fortawesome/free-solid-svg-icons'
import { faCalendarDays } from '@fortawesome/free-solid-svg-icons'
import { faLink } from '@fortawesome/free-solid-svg-icons'
import { faSliders } from '@fortawesome/free-solid-svg-icons'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { faDownload } from '@fortawesome/free-solid-svg-icons'
import CdexCodes_dc from './CdexCodes_dc.js'
import ClassificationCodes_dc from './ClassificationCodes_dc.js'
import RegressionTests from '../components/regression/RegressionTests.js'
import PaginationComponent from '../components/pagination/PaginationComponent.js'
import SpinnerComponent from '../components/progressbar/SpinnerComponent.js'
import { formatRelativeDateTime, formatFullDateTime } from '../lib/formatRelativeDateTime.js'
import { useAuth0 } from "@auth0/auth0-react";
import { apiGet, apiPut } from "../services/AuthService.js";
//custom gold theme styling
import {
    btnGold, btnGoldHover, FOCUS_GOLD, COLORS,
    header, footer, goldLinkBase, addUnderline, removeUnderline,
    boxshadowHover, boxshadowUnHover,
    showAdvancedBtn, searchBtn, uploadBtn, resetFiltersBtn, sourceDataBtn,
    statusColors, darkStatusColors,
    formLabel, columnTitle, columnSortLink, goldInputFocus, statusLabel,
    frame, goldFaPlus, faIconStyle,
    inputSm, paginationStyle, activePaginationStyle,
    dropDownToggle, dropDownInput, dropDownMenu, tableRowHover, tableRowUnHover,
    resetBtnGrey, stickyThStyle, adminStickyThStyle, filterActiveIndicator, backBtn
} from '../styles/goldTheme.js'

function CustomDatePicker({ value, onChange, isInvalid }) {
    const [show, setShow] = useState(false);
    const [popupPos, setPopupPos] = useState({ top: 0, left: 0 });
    const containerRef = useRef(null);
    const today = new Date();
    const selectedDate = value ? new Date(value + 'T00:00:00') : null;
    const [viewYear, setViewYear] = useState(selectedDate ? selectedDate.getFullYear() : today.getFullYear());
    const [viewMonth, setViewMonth] = useState(selectedDate ? selectedDate.getMonth() : today.getMonth());

    useEffect(() => {
        if (value) {
            const d = new Date(value + 'T00:00:00');
            setViewYear(d.getFullYear());
            setViewMonth(d.getMonth());
        }
    }, [value]);

    useEffect(() => {
        const handleOutside = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                setShow(false);
            }
        };
        if (show) document.addEventListener('mousedown', handleOutside);
        return () => document.removeEventListener('mousedown', handleOutside);
    }, [show]);

    const openCalendar = () => {
        if (containerRef.current) {
            const rect = containerRef.current.getBoundingClientRect();
            setPopupPos({ top: rect.bottom + 4, left: rect.left });
        }
        setShow(s => !s);
    };

    const MONTH_NAMES = ['January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'];
    const DAY_LABELS = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];

    const daysInMonth = new Date(viewYear, viewMonth + 1, 0).getDate();
    const firstDayOfWeek = new Date(viewYear, viewMonth, 1).getDay();
    const cells = [];
    for (let i = 0; i < firstDayOfWeek; i++) cells.push(null);
    for (let d = 1; d <= daysInMonth; d++) cells.push(d);
    while (cells.length % 7 !== 0) cells.push(null);

    const isSelected = (day) =>
        day && selectedDate &&
        selectedDate.getFullYear() === viewYear &&
        selectedDate.getMonth() === viewMonth &&
        selectedDate.getDate() === day;

    const isToday = (day) =>
        day &&
        today.getFullYear() === viewYear &&
        today.getMonth() === viewMonth &&
        today.getDate() === day;

    const handleDaySelect = (day) => {
        const formatted = `${viewYear}-${String(viewMonth + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
        onChange(formatted);
        setShow(false);
    };

    const prevMonth = () => {
        if (viewMonth === 0) { setViewMonth(11); setViewYear(y => y - 1); }
        else setViewMonth(m => m - 1);
    };

    const nextMonth = () => {
        if (viewMonth === 11) { setViewMonth(0); setViewYear(y => y + 1); }
        else setViewMonth(m => m + 1);
    };

    const displayValue = selectedDate
        ? `${String(selectedDate.getMonth() + 1).padStart(2, '0')}/${String(selectedDate.getDate()).padStart(2, '0')}/${selectedDate.getFullYear()}`
        : '';

    return (
        <div ref={containerRef} style={{ position: 'relative' }}>
            <InputGroup size="sm">
                <Form.Control
                    size="sm"
                    readOnly
                    value={displayValue}
                    placeholder="MM/DD/YYYY"
                    onClick={openCalendar}
                    isInvalid={isInvalid}
                    style={{ cursor: 'pointer', backgroundColor: '#fff', borderRight: 'none' }}
                />
                <InputGroup.Text
                    onClick={openCalendar}
                    style={{ cursor: 'pointer', backgroundColor: '#fff', borderLeft: 'none', color: COLORS.gold }}
                >
                    <FontAwesomeIcon icon={faCalendarDays} />
                </InputGroup.Text>
            </InputGroup>
            {show && (
                <div style={{
                    position: 'fixed',
                    zIndex: 1050,
                    top: popupPos.top,
                    left: popupPos.left,
                    backgroundColor: '#fff',
                    border: '1px solid #dee2e6',
                    borderRadius: '8px',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                    padding: '12px 14px',
                    minWidth: '244px',
                    userSelect: 'none'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px' }}>
                        <button type="button" onClick={prevMonth}
                            style={{ background: 'none', border: 'none', cursor: 'pointer', color: COLORS.gold, fontSize: '1.3rem', lineHeight: 1, padding: '0 4px' }}>
                            ‹
                        </button>
                        <span style={{ fontWeight: 600, fontSize: '0.9rem', color: '#212529' }}>
                            {MONTH_NAMES[viewMonth]} {viewYear}
                        </span>
                        <button type="button" onClick={nextMonth}
                            style={{ background: 'none', border: 'none', cursor: 'pointer', color: COLORS.gold, fontSize: '1.3rem', lineHeight: 1, padding: '0 4px' }}>
                            ›
                        </button>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '2px', marginBottom: '4px' }}>
                        {DAY_LABELS.map(d => (
                            <div key={d} style={{ textAlign: 'center', fontSize: '0.72rem', fontWeight: 700, color: '#6c757d', paddingBottom: '4px' }}>{d}</div>
                        ))}
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '2px' }}>
                        {cells.map((day, i) => (
                            <div
                                key={i}
                                onClick={() => day && handleDaySelect(day)}
                                style={{
                                    textAlign: 'center',
                                    padding: '5px 2px',
                                    borderRadius: '4px',
                                    fontSize: '0.83rem',
                                    cursor: day ? 'pointer' : 'default',
                                    backgroundColor: isSelected(day) ? COLORS.gold : 'transparent',
                                    color: isSelected(day) ? '#fff' : isToday(day) ? COLORS.gold : day ? '#212529' : 'transparent',
                                    fontWeight: isSelected(day) || isToday(day) ? 600 : 400,
                                    outline: isToday(day) && !isSelected(day) ? `1px solid ${COLORS.gold}` : 'none',
                                }}
                                onMouseEnter={e => { if (day && !isSelected(day)) e.currentTarget.style.backgroundColor = '#f5f0e8'; }}
                                onMouseLeave={e => { if (day && !isSelected(day)) e.currentTarget.style.backgroundColor = 'transparent'; }}
                            >
                                {day || ''}
                            </div>
                        ))}
                    </div>
                    <div style={{ textAlign: 'center', marginTop: '10px', borderTop: '1px solid #dee2e6', paddingTop: '8px' }}>
                        <button
                            type="button"
                            onClick={() => { setViewYear(today.getFullYear()); setViewMonth(today.getMonth()); handleDaySelect(today.getDate()); }}
                            style={{ background: 'none', border: 'none', cursor: 'pointer', color: COLORS.gold, fontSize: '0.8rem', fontWeight: 500 }}
                        >
                            Today
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}

function LoadingRow({ colSpan = 12 }) {
    return (
        <tr>
            <td colSpan={colSpan} className="text-center">
                <Spinner animation="border" style={{ color: COLORS.gold }} />
            </td>
        </tr>
    )
}

const AdminDashboard = (props) => {
    const baseUrl = process.env.REACT_APP_API_BASEURL;
    const { getAccessTokenSilently } = useAuth0();
    const navigate = useNavigate();
    const location = useLocation();

    const [
        currentAccount,
        accountProfile,
        setAccountProfile,
        toggleIsShowSidebarMd,
        setIsShowSidebarMd
    ] = useOutletContext();

    const [dataCriteria, setDataCriteria] = useState({
        skipCount: 0,
        takeCount: 25,
        companyTypeId: -1,
        companyName: '',
        accountingSystem: '',
        jibAccountingSystemId: -1,
        membershipStatus: '',
        docConversionNetworkTypeId: -1,
        docConversionOutputTypeId: -1,
        sortBy: "CompanyName",
        sortDirection: "descending"
    });

    const [userDataCriteria, setUserDataCriteria] = useState({
        skipCount: 0,
        takeCount: 25,
        companyTypeId: -1,
        companyName: '',
        firstName: '',
        lastName: '',
        email: '',
        membershipStatus: ''
    });

    const [searchCompanyValue, setSearchCompanyValue] = useState('');
    const [dataStatus, setDataStatus] = useState('');
    const [downloadDataStatus, setDownloadDataStatus] = useState('');
    const [rowCount, setRowCount] = useState(0);
    const [userRowCount, setUserRowCount] = useState(0);
    const [pageStatus, setPageStatus] = useState('loading');
    const [pageErrors, setPageErrors] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [currentUserPage, setCurrentUserPage] = useState(1);
    const [dataErrors, setDataErrors] = useState('');
    const [screenHeight, setScreenHeight] = useState(100);
    const [selectedAccountId, setSelectedAccountId] = useState(null);
    const [activeTab, setActiveTab] = useState('companies');

    //which view is showing inside the Global Mappings tab: 'menu' (the two cards),
    //'cdex' (embedded CdexCodes_dc), or 'jib' (embedded ClassificationCodes_dc)
    const [globalMappingsView, setGlobalMappingsView] = useState('menu');

    //Id of the Account row flagged IsGlobalMapping = true — fetched dynamically so
    //the Document Conversion tab works in any environment (Dev / QA / Prod use
    //different account ids). Passed to the embedded CdexCodes_dc on render.
    const [globalAccountId, setGlobalAccountId] = useState(null);

    const [searchUserValue, setSearchUserValue] = useState('');
    const [filteredUsers, setFilteredUsers] = useState([]);

    const [allCompanies, setAllCompanies] = useState([]);
    const [allUsers, setAllUsers] = useState([]);

    const [selectedDocConvOption, setSelectedDocConvOption] = useState("");

    const [hoveredBtn, setHoveredBtn] = useState(null);

    const [sortBy, setSortBy] = useState("CompanyName");
    const [sortDirection, setSortDirection] = useState("descending");

    const [sortUsersBy, setSortUsersBy] = useState("CompanyName");
    const [sortUsersDirection, setSortUsersDirection] = useState("descending");

    const isAccountSettingsEnabled = (baseUrl && (baseUrl.includes("local") || baseUrl.includes("dev") || baseUrl.includes("qa") || baseUrl.includes("totdata-api.azurewebsites.net")));

    //initialize page
    useEffect(() => {
        (async () => {
            if (setIsShowSidebarMd && accountProfile.accountId === "1") {
                setIsShowSidebarMd(false);
            }

            const height = window.innerHeight;
            setScreenHeight(height);
            setPageStatus("ready");

            //fetch the Global Mapping account id so the Document Conversion tab can pass
            //it to the embedded CdexCodes_dc (varies per env, was previously hardcoded 69)
            try {
                const resp = await apiGet('accounts/GlobalMapping/Id', getAccessTokenSilently);
                if (resp.ok) {
                    const id = await resp.json();
                    if (id) setGlobalAccountId(id);
                }
            } catch (ex) {
                console.log('Failed to load global mapping account id: ' + (ex.message || ex));
            }

            const saved = location.state?.adminDash;
            if (!saved) return;

            setDataCriteria(saved.dataCriteria);
            setUserDataCriteria(saved.userDataCriteria);
            setSortBy(saved.sortBy);
            setSortDirection(saved.sortDirection);
            setCurrentPage(saved.currentPage || 1);
            setCurrentUserPage(saved.currentUserPage || 1);

            if (saved.dataCriteria) {
                setDataStatus("loading");

                const page = saved.currentPage || 1;
                const take = saved.dataCriteria.takeCount;
                const skip = page === 1 ? 0 : (page - 1) * take;

                await populateCompanies(
                    { ...saved.dataCriteria, skipCount: skip },
                    saved.sortBy,
                    saved.sortDirection
                )
                    .then((resp) => {
                        if (!resp.data || resp.data.length === 0) {
                            setDataStatus("nodata");
                        } else {
                            setRowCount(resp.data[0].rowCount);
                            setAllCompanies(resp.data);
                            setDataStatus("ready");
                        }
                    })
                    .catch((ex) => {
                        setDataStatus("error");
                        setDataErrors(ex.message);
                    });
            }

            setTimeout(() => {
                if (scrollContainerRef.current) {
                    scrollContainerRef.current.scrollTop = saved.scrollTop || 0;
                }
            }, 0);
        })();
    }, []);


    //populate companies
    const populateCompanies = async (currentCriteria, sortBy, sortDirection) => {
        const apiUrl =
            'a_report/companiesbycriteria?' +
            '&skipCount=' + currentCriteria.skipCount +
            '&takeCount=' + currentCriteria.takeCount +
            '&companyName=' + currentCriteria.companyName +
            '&companyTypeId=' + currentCriteria.companyTypeId +
            '&accountingSystem=' + currentCriteria.accountingSystem +
            '&jibAccountingSystemId=' + currentCriteria.jibAccountingSystemId +
            '&membershipStatus=' + currentCriteria.membershipStatus +
            '&docConversionNetworkTypeId=' + currentCriteria.docConversionNetworkTypeId +
            '&docConversionOutputTypeId=' + currentCriteria.docConversionOutputTypeId +
            '&sortBy=' + sortBy +
            '&sortDirection=' + sortDirection;

        const response = await apiGet(apiUrl, getAccessTokenSilently);
        const json = await response.json();
        setAllCompanies(json);
        console.log('Response - Status: ' + response.status + ', Success: ' + response.ok + ', Json: ' + JSON.stringify(json));

        return { success: response.ok, data: json };
    };

    //populate users
    const populateUsers = async (currentUserCriteria, sortUsersBy, sortUsersDirection) => {
        const apiUrl =
            'a_report/usersbycriteria?' +
            '&skipCount=' + currentUserCriteria.skipCount +
            '&takeCount=' + currentUserCriteria.takeCount +
            '&companyName=' + currentUserCriteria.companyName +
            '&companyTypeId=' + currentUserCriteria.companyTypeId +
            '&firstName=' + currentUserCriteria.firstName +
            '&lastName=' + currentUserCriteria.lastName +
            '&email=' + currentUserCriteria.email +
            '&membershipStatus=' + currentUserCriteria.membershipStatus +
            '&sortUsersBy=' + sortUsersBy +
            '&sortUsersDirection=' + sortUsersDirection;

        const response = await apiGet(apiUrl, getAccessTokenSilently);
        const json = await response.json();
        setAllUsers(json);
        console.log('Response - Status: ' + response.status + ', Success: ' + response.ok + ', Json: ' + JSON.stringify(json));

        return { success: response.ok, data: json };
    };

    ////tester
    //const populastUserLastLogin = async () => {
    //    const apiUrl = 'a_report/UserLastLogin'

    //    const response = await apiGet(apiUrl, getAccessTokenSilently);
    //    console.log('Response - Status: ' + response.status + ', Success: ' + response.ok);

    //    return { success: response.ok };
    //};

    const saveAdminDashState = (override = {}) => {
        navigate(location.pathname + location.search, {
            replace: true,
            state: {
                adminDash: {
                    dataCriteria,
                    userDataCriteria,
                    sortBy,
                    sortDirection,
                    currentPage,
                    currentUserPage,
                    activeTab,
                    scrollTop: scrollContainerRef.current ? scrollContainerRef.current.scrollTop : 0,
                    ...override
                }
            }
        });
    };

    const handleChange = (event) => {
        event.preventDefault();

        const fieldName = event.target.name;
        const value = event.target.value;

        setDataCriteria({
            ...dataCriteria,
            [fieldName]: value
        });
    }

    const handleUserChange = (event) => {
        event.preventDefault();

        const fieldName = event.target.name;
        const value = event.target.value;

        setUserDataCriteria({
            ...userDataCriteria,
            [fieldName]: value
        });
    }

    //search criteria helper so drop down items can call a search
    const runCompanySearch = async (criteriaOverride = {}) => {
        setDataStatus('loading');

        setCurrentPage(1);

        const currentCriteria = {
            ...dataCriteria,
            ...criteriaOverride,
            skipCount: 0
        };

        //setSelectedDocConvOption("-1");

        console.log("\nSEARCHING WITH THE FOLLOWING CRITERIA:\n")
        console.log(currentCriteria);

        await populateCompanies(currentCriteria, sortBy, sortDirection)
            .then(response => {
                if (response.data.length === 0) {
                    console.log(response.data);
                    setDataStatus('nodata')
                }
                else {
                    //console.log('DataFile Count: ' + response.data[0].rowCount);
                    setRowCount(response.data[0].rowCount);
                    setAllCompanies(response.data);
                    setDataStatus('ready')
                    setSelectedAccountId(accountProfile.accountId);
                }
            })
            .catch(ex => {
                setDataStatus('error');
                setDataErrors(ex.message);
            })
            .finally(response => {
                //do something
            })
    };

    //search criteria helper so drop down items can call a search
    const runUserSearch = async (criteriaOverride = {}) => {
        setDataStatus('loading');

        setCurrentUserPage(1);

        const currentCriteria = {
            ...userDataCriteria,
            ...criteriaOverride,
            skipCount: 0
        };

        //setSelectedDocConvOption("-1");

        console.log("\nSEARCHING WITH THE FOLLOWING CRITERIA:\n")
        console.log(currentCriteria);

        await populateUsers(currentCriteria)
            .then(response => {
                if (response.data.length === 0) {
                    console.log(response.data);
                    setDataStatus('nodata')
                }
                else {
                    //console.log('DataFile Count: ' + response.data[0].rowCount);
                    setUserRowCount(response.data[0].rowCount);
                    setAllUsers(response.data);
                    setDataStatus('ready')
                    setSelectedAccountId(accountProfile.accountId);
                }
            })
            .catch(ex => {
                setDataStatus('error');
                setDataErrors(ex.message);
            })
            .finally(response => {
                //do something
            })
    };

    //Grab data only when searched for
    const submitForm = async (e) => {
        e.preventDefault();
        runCompanySearch();
    };

    //Grab data only when searched for
    const submitUserForm = async (e) => {
        e.preventDefault();
        runUserSearch();
    };

    function getCompanyTypeName(companyTypeId) {
        switch (companyTypeId) {
            case 1:
                return 'Operator';
            case 4:
                return 'Owner'
            default:
                return companyTypeId.toString;
        }
    }

    function getJIBAccountingSystemIdName(jibAccountingSystemId) {
        if (jibAccountingSystemId == null || jibAccountingSystemId === -1) return 'NA';
        switch (jibAccountingSystemId) {
            case 1:
                return 'NA';
            case 2:
                return 'EnergyLink XML';
            case 3:
                return 'W Energy';
            case 4:
                return 'Quorum PDS';
            case 5:
                return 'EnergyLink XML v2';
            case 6:
                return 'Enertia2';
            case 7:
                return 'IntegraAvatar';
            case 8:
                return 'SAP-Crescent'
            case 9:
                return 'EnergyLinkCsv'
            case 10:
                return 'Bolo'
            default:
                return 'NA';
        }
    }

    function getDocConvNetworkTypeName(docConvType) {
        switch (docConvType) {
            case 1:
                return 'IMTS';
            case 2:
                return ''
            default:
                return '';
        }
    }

    function getDocConvOutputTypeName(docConvType) {
        switch (docConvType) {
            case 1:
                return 'OGSYS_PCX';
            case 2:
                return 'CDEX'
            case 3:
                return 'EL_XLS'
            default:
                return '';
        }
    }

    const handleCompanyChange = async (id) => {
        //const fieldName = event.target.name;
        const value = id;
        //console.log('Field: ' + fieldName + ', Value: ' + value);

        setSelectedAccountId(value);
        setDataStatus('loading');

        await getAccountSwitch(value)
            .then(response => {
                if (response.success) {
                    localStorage.removeItem('dataFileState');

                    //refresh site at admin dashboard page with new token
                    window.location.href = window.location.origin;
                } else {
                    setAllCompanies([]);
                }
            })
            .catch(ex => {
                //setPageStatus('error');
                //setPageErrors(ex.message);
            })
            .finally(response => {
                setDataStatus('ready');
            })
    };

    const handleCompanyTypeChange = async (e) => {
        const newValue = e.target.value;

        setDataCriteria((prev) => ({
            ...prev,
            companyTypeId: parseInt(newValue, 10)
        }));

        setCurrentPage(1);

        try {
            setDataStatus('loading');

            const currentCriteria = {
                ...dataCriteria,
                skipCount: 0,
                companyTypeId: parseInt(newValue, 10)
            };

            const response = await populateCompanies(currentCriteria, sortBy, sortDirection);
            if (response.data.length === 0) {
                setDataStatus('nodata');
            } else {
                setRowCount(response.data[0].rowCount);
                setAllCompanies(response.data);
                setDataStatus('ready');
            }
        } catch (err) {
            setDataStatus('error');
            setDataErrors(err.message);
        }
    };

    const handleAccountingSystemChange = async (e) => {
        var newValue = e.target.value;

        if (newValue === "-1") {
            newValue = ""
        }

        setDataCriteria((prev) => ({
            ...prev,
            accountingSystem: newValue
        }));

        setCurrentPage(1);

        try {
            setDataStatus('loading');

            const currentCriteria = {
                ...dataCriteria,
                skipCount: 0,
                accountingSystem: newValue
            };

            const response = await populateCompanies(currentCriteria, sortBy, sortDirection);
            if (response.data.length === 0) {
                setDataStatus('nodata');
            } else {
                setRowCount(response.data[0].rowCount);
                setAllCompanies(response.data);
                setDataStatus('ready');
            }
        } catch (err) {
            setDataStatus('error');
            setDataErrors(err.message);
        }
    };

    const handleJIBAccountingSystemIdChange = async (e) => {
        var newValue = e.target.value;

        if (newValue === "-1") {
            newValue = -1
        }

        setDataCriteria((prev) => ({
            ...prev,
            jibAccountingSystemId: newValue
        }));

        setCurrentPage(1);

        try {
            setDataStatus('loading');

            const currentCriteria = {
                ...dataCriteria,
                skipCount: 0,
                jibAccountingSystemId: newValue
            };

            const response = await populateCompanies(currentCriteria, sortBy, sortDirection);
            if (response.data.length === 0) {
                setDataStatus('nodata');
            } else {
                setRowCount(response.data[0].rowCount);
                setAllCompanies(response.data);
                setDataStatus('ready');
            }
        } catch (err) {
            setDataStatus('error');
            setDataErrors(err.message);
        }
    };

    const handleMemberChange = async (e) => {
        var newValue = e.target.value;

        if (newValue === "-1") {
            newValue = ""
        }

        setDataCriteria((prev) => ({
            ...prev,
            membershipStatus: newValue
        }));

        setCurrentPage(1);

        try {
            setDataStatus('loading');

            const currentCriteria = {
                ...dataCriteria,
                skipCount: 0,
                membershipStatus: newValue
            };

            const response = await populateCompanies(currentCriteria, sortBy, sortDirection);
            if (response.data.length === 0) {
                setDataStatus('nodata');
            } else {
                setRowCount(response.data[0].rowCount);
                setAllCompanies(response.data);
                setDataStatus('ready');
            }
        } catch (err) {
            setDataStatus('error');
            setDataErrors(err.message);
        }
    };

    const DOC_CONV_MAP = {
        "-1": { network: -1, output: -1 },  // All
        "1": { network: 1, output: -1 },    // IMTS
        "2": { network: 2, output: -1 },    // TOTDATA - All
        "3": { network: 2, output: 1 },     // TOTDATA - Delimited
        "4": { network: 2, output: 2 },     // TOTDATA - Cdex
        "5": { network: 2, output: 3 }      // TOTDATA - Xlsx
    };

    const handleDocConversionTypeChange = async (e) => {
        const selected = e.target.value;

        const mapEntry = DOC_CONV_MAP[selected] || { network: -1, output: -1 };
        const networkId = mapEntry.network;
        const outputId = mapEntry.output;

        setDataCriteria((prev) => ({
            ...prev,
            docConversionNetworkTypeId: networkId,
            docConversionOutputTypeId: outputId
        }));

        setCurrentPage(1);

        try {
            setDataStatus("loading");

            const currentCriteria = {
                ...dataCriteria,
                skipCount: 0,
                docConversionNetworkTypeId: networkId,
                docConversionOutputTypeId: outputId
            };

            const response = await populateCompanies(currentCriteria, sortBy, sortDirection);

            if (response.data.length === 0) {
                setDataStatus("nodata");
            } else {
                setRowCount(response.data[0].rowCount);
                setAllCompanies(response.data);
                setDataStatus("ready");
            }
        } catch (err) {
            setDataStatus("error");
            setDataErrors(err.message);
        }
    };

    const handleUserMemberChange = async (e) => {
        var newValue = e.target.value;

        if (newValue === "-1") {
            newValue = ""
        }

        setUserDataCriteria((prev) => ({
            ...prev,
            membershipStatus: newValue
        }));

        setCurrentPage(1);

        try {
            setDataStatus('loading');

            const currentUserCriteria = {
                ...userDataCriteria,
                skipCount: 0,
                membershipStatus: newValue
            };

            const response = await populateUsers(currentUserCriteria);
            if (response.data.length === 0) {
                setDataStatus('nodata');
            } else {
                setRowCount(response.data[0].rowCount);
                setAllUsers(response.data);
                setDataStatus('ready');
            }
        } catch (err) {
            setDataStatus('error');
            setDataErrors(err.message);
        }
    };

    //get account switch
    const getAccountSwitch = async (accountId) => {
        //console.log('Switching Account...');

        const apiUrl = 'accounts/accountswitch/' + accountId;
        //console.log(apiUrl);

        const response = await apiGet(apiUrl, getAccessTokenSilently);
        const json = response.ok ? await response.json() : [];
        console.log('Response - Status: ' + response.status + ', Success: ' + response.ok + ', Json: ' + JSON.stringify(json));

        return { success: response.ok, data: json };
    };

    const handlePageClick = async (currentPage) => {
        console.log('Current Page: ' + currentPage);

        setDataStatus('loading');

        let skipCount = (currentPage === 1 ? 0 : (currentPage - 1) * dataCriteria.takeCount);
        console.log('Skip Count: ' + skipCount);
        setDataCriteria({
            ...dataCriteria,
            skipCount: skipCount
        });

        const currentCriteria = {
            ...dataCriteria,
            skipCount: skipCount
        };

        await populateCompanies(currentCriteria, sortBy, sortDirection)
            .then(response => {
                if (response.data.length === 0) {
                    console.log(response.data);
                    setDataStatus('nodata')
                }
                else {
                    setAllCompanies(response.data);
                    setDataStatus('ready')
                }
            })
            .catch(ex => {
                setDataStatus('error');
                setDataErrors(ex.message);
            })
            .finally(response => {
                //do something
            })

        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollTop = 0;
        }
    };

    const handleUserPageClick = async (currentUserPage) => {
        console.log('Current Page: ' + currentUserPage);

        setDataStatus('loading');

        let skipCount = (currentUserPage === 1 ? 0 : (currentUserPage - 1) * userDataCriteria.takeCount);
        console.log('Skip Count: ' + skipCount);
        setUserDataCriteria({
            ...userDataCriteria,
            skipCount: skipCount
        });

        const currentCriteria = {
            ...userDataCriteria,
            skipCount: skipCount
        };

        await populateUsers(currentCriteria)
            .then(response => {
                if (response.data.length === 0) {
                    console.log(response.data);
                    setDataStatus('nodata')
                }
                else {
                    setAllUsers(response.data);
                    setDataStatus('ready')
                }
            })
            .catch(ex => {
                setDataStatus('error');
                setDataErrors(ex.message);
            })
            .finally(response => {
                //do something
            })

        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollTop = 0;
        }
    };

    const handleExportXls = async () => {
        setDownloadDataStatus('loading');
        const currentCriteria = {
            ...dataCriteria,
            skipCount: -1,
            takeCount: -1
        };
        try {
            const apiUrl =
                'a_report/companiesbycriteriaexcel?' +
                '&skipCount=' + currentCriteria.skipCount +
                '&takeCount=' + currentCriteria.takeCount +
                '&companyName=' + currentCriteria.companyName +
                '&companyTypeId=' + currentCriteria.companyTypeId +
                '&accountingSystem=' + currentCriteria.accountingSystem +
                '&jibAccountingSystemId=' + currentCriteria.jibAccountingSystemId +
                '&membershipStatus=' + currentCriteria.membershipStatus +
                '&docConversionNetworkTypeId=' + currentCriteria.docConversionNetworkTypeId +
                '&docConversionOutputTypeId=' + currentCriteria.docConversionOutputTypeId
            const fetchResponse = await apiGet(apiUrl, getAccessTokenSilently);
            console.log("Response is:", fetchResponse);
            const blob = await fetchResponse.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Companies.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            setDownloadDataStatus('ready');
        } catch (err) {
            setDownloadDataStatus('error');
            console.error("Error exporting XLSX:", err);
        }
    };

    const handleExportUserXls = async () => {
        setDownloadDataStatus('loading');
        const currentUserCriteria = {
            ...userDataCriteria,
            skipCount: -1,
            takeCount: -1
        };
        try {
            const apiUrl =
                'a_report/usersbycriteriaexcel?' +
                '&skipCount=' + currentUserCriteria.skipCount +
                '&takeCount=' + currentUserCriteria.takeCount +
                '&companyName=' + currentUserCriteria.companyName +
                '&companyTypeId=' + currentUserCriteria.companyTypeId +
                '&firstName=' + currentUserCriteria.firstName +
                '&lastName=' + currentUserCriteria.lastName +
                '&email=' + currentUserCriteria.email +
                '&membershipStatus=' + currentUserCriteria.membershipStatus
            const fetchResponse = await apiGet(apiUrl, getAccessTokenSilently);
            console.log("Response is:", fetchResponse);
            const blob = await fetchResponse.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Users.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            setDownloadDataStatus('ready');
        } catch (err) {
            setDownloadDataStatus('error');
            console.error("Error exporting XLSX:", err);
        }
    };

    const handleResetCompanyFilters = () => {

        setDataCriteria(prev => ({
            ...prev,
            skipCount: 0,
            takeCount: 25,
            companyTypeId: -1,
            companyName: '',
            accountingSystem: '',
            jibAccountingSystemId: -1,
            membershipStatus: '',
            docConversionNetworkTypeId: -1,
            docConversionOutputTypeId: -1,
            sortBy: "CompanyName",
            sortDirection: "descending"
        }));


        setCurrentPage(1);
        setSelectedDocConvOption("-1");
        setSortBy("CompanyName");
        setSortDirection("descending");

        setAllCompanies([]);
        setRowCount(0);
        setDataStatus("nodata");
    };

    const handleResetUserFilters = () => {

        setUserDataCriteria(prev => ({
            ...prev,
            skipCount: 0,
            takeCount: 25,
            companyTypeId: -1,
            companyName: '',
            firstName: '',
            lastName: '',
            email: '',
            membershipStatus: ''
        }));

        setCurrentUserPage(1);
        setSortUsersBy("UserName");
        setSortUsersDirection("descending")

        setAllUsers([]);
        setUserRowCount(0);
        setDataStatus("nodata");
        
    };

    //const handleTestUserLogin = () => {
    //    populastUserLastLogin();
    //};

    const scrollContainerRef = useRef(null);


    //-------------INVENTORY REPORT HELPER------------
    const monthOptions = [
        { num: 1, name: "January" },
        { num: 2, name: "February" },
        { num: 3, name: "March" },
        { num: 4, name: "April" },
        { num: 5, name: "May" },
        { num: 6, name: "June" },
        { num: 7, name: "July" },
        { num: 8, name: "August" },
        { num: 9, name: "September" },
        { num: 10, name: "October" },
        { num: 11, name: "November" },
        { num: 12, name: "December" }
    ];

    const curYear = new Date().getFullYear();
    const yearOptions = [];
    const nowYear = new Date().getFullYear();
    for (let y = nowYear - 4; y <= nowYear + 1; y++) {
        yearOptions.push(y);
    }

    const [month, setMonth] = useState(new Date().getMonth() + 1);
    const [year, setYear] = useState(curYear);
    function InventoryControls({ onGenerate }) {
        return (
            <Form onSubmit={e => { e.preventDefault(); onGenerate(month, year); }}>
                <Row className="align-items-end g-3">
                    <Col xs={12} md={1}>
                        <Form.Group controlId="invMonth">
                            <Form.Label>Month</Form.Label>
                            <Form.Select
                                value={month}
                                onChange={e => setMonth(parseInt(e.target.value, 10))}
                            >
                                {monthOptions.map(m => (
                                    <option key={m.num} value={m.num}>{m.name}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    </Col>

                    <Col xs={12} md={1}>
                        <Form.Group controlId="invYear">
                            <Form.Label>Year</Form.Label>
                            <Form.Select
                                value={year}
                                onChange={e => setYear(parseInt(e.target.value, 10))}
                            >
                                {yearOptions.map(y => (
                                    <option key={y} value={y}>{y}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    </Col>

                    <Col xs={12} md={1}>
                        {downloadDataStatus === 'loading' ? (
                            <Button variant="primary" diasabled>
                                <Spinner
                                    as="span"
                                    animation="grow"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                            </Button>
                        ) : (
                            <Button type="submit" className="w-100">Generate</Button>
                        )}
                    </Col>
                </Row>
            </Form>
        );
    }

    // Billing Report DatePicker Variables
    const now = new Date();
    const toFirstOfMonth = (m, y) => `${y}-${String(m).padStart(2, '0')}-01`;
    const nextMonthDate = new Date(now.getFullYear(), now.getMonth() + 1, 1); // first day of next month
    const formatDate = (d) => d.toISOString().split('T')[0];

    const getFirstOfCurrentMonth = () => {
        const d = new Date();
        return formatDate(new Date(d.getFullYear(), d.getMonth(), 1));
    };

    const getLastOfCurrentMonth = () => {
        const d = new Date();
        return formatDate(new Date(d.getFullYear(), d.getMonth() + 1, 0));
    };

    const billingBaseDate = new Date();
    billingBaseDate.setMonth(billingBaseDate.getMonth() + 1);
    billingBaseDate.setDate(1); // normalize to first of month

    const [billingMonth, setBillingMonth] = useState(billingBaseDate.getMonth() + 1);
    const [billingYear, setBillingYear] = useState( billingBaseDate.getFullYear() );
    const [periodStart, setPeriodStart] = useState(getFirstOfCurrentMonth());
    const [periodEnd, setPeriodEnd] = useState(getLastOfCurrentMonth());

    const [isGlobalBillingDateInvalid, setIsGlobalBillingDateInvalid] = useState(false);
    const [isPeriodStartInvalid, setIsPeriodStartInvalid] = useState(false);
    const [isPeriodEndInvalid, setIsPeriodEndInvalid] = useState(false);
    function DocumentBillingControls({ onGenerate }) {
        return (
            <Form onSubmit={e => { e.preventDefault(); onGenerate(billingMonth, billingYear, periodStart, periodEnd); }}>
                <Row className="align-items-end g-3 mb-5">
                    <Col xs={12} md={2}>
                        <Form.Group controlId="billingMonth">
                            <Form.Label>Billing Month (OLD)</Form.Label>
                            <Form.Select
                                size="sm"
                                value={billingMonth}
                                onChange={e => {
                                    setBillingMonth(parseInt(e.target.value, 10));
                                    setIsGlobalBillingDateInvalid(false);
                                }}
                                isInvalid={isGlobalBillingDateInvalid}
                                style={{ ...inputSm }}
                            >
                                {monthOptions.map(m => (
                                    <option key={m.num} value={m.num}>{m.name}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col xs={12} md={1}>
                        <Form.Group controlId="billingYear">
                            <Form.Label>Billing Year</Form.Label>
                            <Form.Select
                                size="sm"
                                value={billingYear}
                                onChange={e => {
                                    setBillingYear(parseInt(e.target.value, 10));
                                    setIsGlobalBillingDateInvalid(false);
                                }}
                                isInvalid={isGlobalBillingDateInvalid}
                                style={{ ...inputSm }}
                            >
                                {yearOptions.map(y => (
                                    <option key={y} value={y}>{y}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>

                <Row className="align-items-end g-3">
                    <Col xs={12} md={2}>
                        <Form.Group controlId="periodStart">
                            <Form.Label>Period Start</Form.Label>
                            <CustomDatePicker
                                value={periodStart}
                                isInvalid={isPeriodStartInvalid}
                                onChange={val => { setPeriodStart(val); setIsPeriodStartInvalid(false); }}
                            />
                        </Form.Group>
                    </Col>

                    <Col xs={12} md={2}>
                        <Form.Group controlId="periodEnd">
                            <Form.Label>Period End</Form.Label>
                            <CustomDatePicker
                                value={periodEnd}
                                isInvalid={isPeriodEndInvalid}
                                onChange={val => { setPeriodEnd(val); setIsPeriodEndInvalid(false); }}
                            />
                        </Form.Group>
                    </Col>

                    <Col xs={12} md={1}>
                        {downloadDataStatus === 'loading' ? (
                        <Button variant="primary" diasabled>
                            <Spinner
                                as="span"
                                animation="grow"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            />
                        </Button>
                            ) : (
                                <Button
                                    type="submit"
                                    className="w-100"
                                    onClick={() => {
                                        // Build billingDate for API
                                        const billingDate01 = toFirstOfMonth(billingMonth, billingYear); // "YYYY-MM-01"

                                        // Required field checks
                                        const billingMissing = !billingMonth || !billingYear;
                                        const startMissing = periodStart === '';
                                        const endMissing = periodEnd === '';

                                        // Ordering checks (only if both dates exist)
                                        const periodOrderInvalid = !startMissing && !endMissing && periodStart > periodEnd;
                                        // billingDate must be ON or AFTER periodEnd

                                        // Set field invalid states
                                        setIsGlobalBillingDateInvalid(billingMissing);
                                        setIsPeriodStartInvalid(startMissing || periodOrderInvalid);
                                        setIsPeriodEndInvalid(endMissing || periodOrderInvalid);

                                    }}
                                    >
                                    Generate
                                </Button>
                            )}
                    </Col>
                </Row>
            </Form>
        );
    }

    async function handleInventoryReportGenerate(reportMonth, reportYear) {
        console.log("Generate report:", reportMonth, reportYear);
        setDownloadDataStatus('loading');
        try {
            const apiUrl =
                'a_report/canpopulateinventoryreport?' +
                'reportMonth=' + reportMonth +
                '&reportYear=' + reportYear + 
                '&includeForever=false'
            const fetchResponse = await apiGet(apiUrl, getAccessTokenSilently);
            console.log("Response is:", fetchResponse);
            const blob = await fetchResponse.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'InventoryReport.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            setDownloadDataStatus('ready');
        } catch (err) {
            setDownloadDataStatus('error');
            console.error("Error exporting XLSX:", err);
        }
    }

    async function handleDocumentBillingGenerate(billingMonth, billingYear, periodStart, periodEnd) {
        console.log("Generate report:", billingMonth, billingYear, periodStart, periodEnd);
        setDownloadDataStatus('loading');
        try {
            const paddedMonth = String(billingMonth).padStart(2, '0');
            const globalBillingDate = `${billingYear}-${paddedMonth}-01`;
            const apiUrl =
                'a_report/CreateBillingReports?' +
                'globalBillingDate=' + encodeURIComponent(globalBillingDate) +
                '&periodStart=' + encodeURIComponent(periodStart) +
                '&periodEnd=' + encodeURIComponent(periodEnd) +
                '&allRecords=true';
            const fetchResponse = await apiGet(apiUrl, getAccessTokenSilently);
            console.log("Response is:", fetchResponse);
            const blob = await fetchResponse.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', globalBillingDate + ' - BillingReports.zip');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            setDownloadDataStatus('ready');
        } catch (err) {
            setDownloadDataStatus('error');
            console.error("Error exporting XLSX:", err);
        }
    }

    // Billing Report (NEW) state — sourced from saved import data. Own state + spinner so it
    // does not share download status with the original Document Billing tab.
    const [billingNewMonth, setBillingNewMonth] = useState(billingBaseDate.getMonth() + 1);
    const [billingNewYear, setBillingNewYear] = useState(billingBaseDate.getFullYear());
    const [billingNewPeriodStart, setBillingNewPeriodStart] = useState(getFirstOfCurrentMonth());
    const [billingNewPeriodEnd, setBillingNewPeriodEnd] = useState(getLastOfCurrentMonth());
    const [isBillingNewDateInvalid, setIsBillingNewDateInvalid] = useState(false);
    const [isBillingNewPeriodStartInvalid, setIsBillingNewPeriodStartInvalid] = useState(false);
    const [isBillingNewPeriodEndInvalid, setIsBillingNewPeriodEndInvalid] = useState(false);
    const [billingNewDownloadStatus, setBillingNewDownloadStatus] = useState('');

    function DocumentBillingControlsNew({ onGenerate }) {
        return (
            <Form onSubmit={e => { e.preventDefault(); onGenerate(billingNewMonth, billingNewYear, billingNewPeriodStart, billingNewPeriodEnd); }}>
                <Row className="align-items-end g-3 mb-5">
                    <Col xs={12} md={2}>
                        <Form.Group controlId="billingNewMonth">
                            <Form.Label>Billing Month</Form.Label>
                            <Form.Select
                                size="sm"
                                value={billingNewMonth}
                                onChange={e => {
                                    setBillingNewMonth(parseInt(e.target.value, 10));
                                    setIsBillingNewDateInvalid(false);
                                }}
                                isInvalid={isBillingNewDateInvalid}
                                style={{ ...inputSm }}
                            >
                                {monthOptions.map(m => (
                                    <option key={m.num} value={m.num}>{m.name}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col xs={12} md={1}>
                        <Form.Group controlId="billingNewYear">
                            <Form.Label>Billing Year</Form.Label>
                            <Form.Select
                                size="sm"
                                value={billingNewYear}
                                onChange={e => {
                                    setBillingNewYear(parseInt(e.target.value, 10));
                                    setIsBillingNewDateInvalid(false);
                                }}
                                isInvalid={isBillingNewDateInvalid}
                                style={{ ...inputSm }}
                            >
                                {yearOptions.map(y => (
                                    <option key={y} value={y}>{y}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>

                <Row className="align-items-end g-3">
                    <Col xs={12} md={2}>
                        <Form.Group controlId="billingNewPeriodStart">
                            <Form.Label>Period Start</Form.Label>
                            <CustomDatePicker
                                value={billingNewPeriodStart}
                                isInvalid={isBillingNewPeriodStartInvalid}
                                onChange={val => { setBillingNewPeriodStart(val); setIsBillingNewPeriodStartInvalid(false); }}
                            />
                        </Form.Group>
                    </Col>

                    <Col xs={12} md={2}>
                        <Form.Group controlId="billingNewPeriodEnd">
                            <Form.Label>Period End</Form.Label>
                            <CustomDatePicker
                                value={billingNewPeriodEnd}
                                isInvalid={isBillingNewPeriodEndInvalid}
                                onChange={val => { setBillingNewPeriodEnd(val); setIsBillingNewPeriodEndInvalid(false); }}
                            />
                        </Form.Group>
                    </Col>

                    <Col xs={12} md={1}>
                        {billingNewDownloadStatus === 'loading' ? (
                        <Button variant="primary" disabled>
                            <Spinner
                                as="span"
                                animation="grow"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            />
                        </Button>
                            ) : (
                                <Button
                                    type="submit"
                                    className="w-100"
                                    onClick={() => {
                                        // Required field checks
                                        const billingMissing = !billingNewMonth || !billingNewYear;
                                        const startMissing = billingNewPeriodStart === '';
                                        const endMissing = billingNewPeriodEnd === '';

                                        // Ordering check (only if both dates exist)
                                        const periodOrderInvalid = !startMissing && !endMissing && billingNewPeriodStart > billingNewPeriodEnd;

                                        setIsBillingNewDateInvalid(billingMissing);
                                        setIsBillingNewPeriodStartInvalid(startMissing || periodOrderInvalid);
                                        setIsBillingNewPeriodEndInvalid(endMissing || periodOrderInvalid);
                                    }}
                                    >
                                    Generate
                                </Button>
                            )}
                    </Col>
                </Row>
            </Form>
        );
    }

    async function handleDocumentBillingGenerateNew(billingMonth, billingYear, periodStart, periodEnd) {
        console.log("Generate NEW billing report:", billingMonth, billingYear, periodStart, periodEnd);
        setBillingNewDownloadStatus('loading');
        try {
            const paddedMonth = String(billingMonth).padStart(2, '0');
            const globalBillingDate = `${billingYear}-${paddedMonth}-01`;
            const apiUrl =
                'a_report/CreateBillingReports_NEW?' +
                'globalBillingDate=' + encodeURIComponent(globalBillingDate) +
                '&periodStart=' + encodeURIComponent(periodStart) +
                '&periodEnd=' + encodeURIComponent(periodEnd) +
                '&allRecords=true';
            const fetchResponse = await apiGet(apiUrl, getAccessTokenSilently);
            console.log("Response is:", fetchResponse);
            const blob = await fetchResponse.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', globalBillingDate + ' - BillingReports (NEW).zip');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            setBillingNewDownloadStatus('ready');
        } catch (err) {
            setBillingNewDownloadStatus('error');
            console.error("Error exporting NEW billing XLSX:", err);
        }
    }

    // Document Usage Report state
    const [usageBillingMonth, setUsageBillingMonth] = useState(billingBaseDate.getMonth() + 1);
    const [usageBillingYear, setUsageBillingYear] = useState(billingBaseDate.getFullYear());
    const [usagePeriodStart, setUsagePeriodStart] = useState(getFirstOfCurrentMonth());
    const [usagePeriodEnd, setUsagePeriodEnd] = useState(getLastOfCurrentMonth());
    const [isUsageBillingDateInvalid, setIsUsageBillingDateInvalid] = useState(false);
    const [isUsagePeriodStartInvalid, setIsUsagePeriodStartInvalid] = useState(false);
    const [isUsagePeriodEndInvalid, setIsUsagePeriodEndInvalid] = useState(false);
    const [usageDownloadStatus, setUsageDownloadStatus] = useState('');

    function DocumentUsageControls({ onGenerate }) {
        return (
            <Form onSubmit={e => { e.preventDefault(); onGenerate(usageBillingMonth, usageBillingYear, usagePeriodStart, usagePeriodEnd); }}>
                <Row className="align-items-end g-3 mb-4">
                    <Col xs={12} sm={6} md={3} lg={2}>
                        <Form.Group controlId="usageBillingMonth">
                            <Form.Label style={{ fontWeight: 500, fontSize: '0.875rem', marginBottom: '0.35rem' }}>Billing Month</Form.Label>
                            <Form.Select
                                value={usageBillingMonth}
                                onChange={e => {
                                    setUsageBillingMonth(parseInt(e.target.value, 10));
                                    setIsUsageBillingDateInvalid(false);
                                }}
                                isInvalid={isUsageBillingDateInvalid}
                                style={{ fontSize: '0.9rem', padding: '0.5rem 0.75rem', borderRadius: '6px', border: '1px solid #ced4da' }}
                                onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                            >
                                {monthOptions.map(m => (
                                    <option key={m.num} value={m.num}>{m.name}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col xs={12} sm={6} md={2} lg={2}>
                        <Form.Group controlId="usageBillingYear">
                            <Form.Label style={{ fontWeight: 500, fontSize: '0.875rem', marginBottom: '0.35rem' }}>Billing Year</Form.Label>
                            <Form.Select
                                value={usageBillingYear}
                                onChange={e => {
                                    setUsageBillingYear(parseInt(e.target.value, 10));
                                    setIsUsageBillingDateInvalid(false);
                                }}
                                isInvalid={isUsageBillingDateInvalid}
                                style={{ fontSize: '0.9rem', padding: '0.5rem 0.75rem', borderRadius: '6px', border: '1px solid #ced4da' }}
                                onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                            >
                                {yearOptions.map(y => (
                                    <option key={y} value={y}>{y}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>

                <Row className="align-items-end g-3">
                    <Col xs={12} sm={6} md={3} lg={2}>
                        <Form.Group controlId="usagePeriodStart">
                            <Form.Label style={{ fontWeight: 500, fontSize: '0.875rem', marginBottom: '0.35rem' }}>Period Start</Form.Label>
                            <CustomDatePicker
                                value={usagePeriodStart}
                                isInvalid={isUsagePeriodStartInvalid}
                                onChange={val => { setUsagePeriodStart(val); setIsUsagePeriodStartInvalid(false); }}
                            />
                        </Form.Group>
                    </Col>

                    <Col xs={12} sm={6} md={3} lg={2}>
                        <Form.Group controlId="usagePeriodEnd">
                            <Form.Label style={{ fontWeight: 500, fontSize: '0.875rem', marginBottom: '0.35rem' }}>Period End</Form.Label>
                            <CustomDatePicker
                                value={usagePeriodEnd}
                                isInvalid={isUsagePeriodEndInvalid}
                                onChange={val => { setUsagePeriodEnd(val); setIsUsagePeriodEndInvalid(false); }}
                            />
                        </Form.Group>
                    </Col>

                    <Col xs={12} sm={6} md={3} lg={2}>
                        {usageDownloadStatus === 'loading' ? (
                            <Button variant="primary" disabled>
                                <Spinner
                                    as="span"
                                    animation="grow"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                            </Button>
                        ) : (
                            <Button
                                type="submit"
                                className="w-100"
                                onClick={() => {
                                    const billingMissing = !usageBillingMonth || !usageBillingYear;
                                    const startMissing = usagePeriodStart === '';
                                    const endMissing = usagePeriodEnd === '';
                                    const periodOrderInvalid = !startMissing && !endMissing && usagePeriodStart > usagePeriodEnd;

                                    setIsUsageBillingDateInvalid(billingMissing);
                                    setIsUsagePeriodStartInvalid(startMissing || periodOrderInvalid);
                                    setIsUsagePeriodEndInvalid(endMissing || periodOrderInvalid);
                                }}
                            >
                                Generate
                            </Button>
                        )}
                    </Col>
                </Row>
            </Form>
        );
    }

    async function handleDocumentUsageGenerate(billingMonth, billingYear, periodStart, periodEnd) {
        console.log("Generate Document Usage report:", billingMonth, billingYear, periodStart, periodEnd);
        setUsageDownloadStatus('loading');
        try {
            const paddedMonth = String(billingMonth).padStart(2, '0');
            const globalBillingDate = `${billingYear}-${paddedMonth}-01`;
            const apiUrl =
                'a_report/CreateDocumentUsageReports?' +
                'globalBillingDate=' + encodeURIComponent(globalBillingDate) +
                '&periodStart=' + encodeURIComponent(periodStart) +
                '&periodEnd=' + encodeURIComponent(periodEnd);
            const fetchResponse = await apiGet(apiUrl, getAccessTokenSilently);
            const blob = await fetchResponse.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', globalBillingDate + ' - DocumentUsageReports.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            setUsageDownloadStatus('ready');
        } catch (err) {
            setUsageDownloadStatus('error');
            console.error("Error exporting Document Usage XLSX:", err);
        }
    }

    // Operator Status Report state
    const [operatorStatusDownloadStatus, setOperatorStatusDownloadStatus] = useState('');

    function OperatorStatusControls({ onGenerate }) {
        return (
            <Form onSubmit={e => { e.preventDefault(); onGenerate(); }}>
                <Row className="align-items-end g-3">
                    <Col xs={12} md={2}>
                        {operatorStatusDownloadStatus === 'loading' ? (
                            <Button variant="primary" disabled>
                                <Spinner
                                    as="span"
                                    animation="grow"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                            </Button>
                        ) : (
                            <Button type="submit" className="w-100">Generate</Button>
                        )}
                    </Col>
                </Row>
            </Form>
        );
    }

    async function handleOperatorStatusGenerate() {
        setOperatorStatusDownloadStatus('loading');
        try {
            const apiUrl = 'a_report/CreateOperatorStatusReport';
            const fetchResponse = await apiGet(apiUrl, getAccessTokenSilently);
            const blob = await fetchResponse.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Operator Info and Status Report.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            setOperatorStatusDownloadStatus('ready');
        } catch (err) {
            setOperatorStatusDownloadStatus('error');
            console.error("Error exporting Operator Status Report:", err);
        }
    }

    // Failed Docs Report state
    const failedDocsWindowOptions = [
        { value: '24h', label: 'Last 24 hours' },
        { value: '7d', label: 'Last 7 days' },
        { value: '30d', label: 'Last 30 days' },
        { value: '365d', label: 'Last 365 days' },
        { value: 'all', label: 'All time' },
    ];
    //Time window for BOTH the grid and the download. Defaults to the last 7 days; changing it reloads the grid.
    const [failedDocsWindow, setFailedDocsWindow] = useState('7d');
    const [failedDocsDownloadStatus, setFailedDocsDownloadStatus] = useState('');
    //Grid data for the Failed Docs report. Same rows the xlsx is built from (one shared query on the
    //API), so the on-screen grid and a downloaded workbook can never disagree.
    const [failedDocsData, setFailedDocsData] = useState(null); // { window, generatedAt, totalCount, summary[], rows[] }
    const [failedDocsError, setFailedDocsError] = useState(null);
    const [failedDocsGridStatus, setFailedDocsGridStatus] = useState('');
    //Doc ids whose full error message is expanded. Collapsed by default: these messages run to a
    //paragraph each, which made every row tall enough to fit only two on screen.
    const [expandedFailedDocIds, setExpandedFailedDocIds] = useState([]);
    //Client chip filter for the grid (null = all clients). Display only: the download is unaffected.
    const [failedDocsClientFilter, setFailedDocsClientFilter] = useState(null);
    //Which Reports sub-tab is showing. Controlled (was defaultActiveKey) so the Failed Docs grid can
    //load itself the moment that pane is opened, instead of waiting for a button press.
    const [reportsView, setReportsView] = useState('inventory');

    //Failed Docs: only the grid scrolls, and it fills the window down to just above the footer. The other
    //report views keep the Reports box's (screenHeight - 480)px cap and scroll inside it; for this view that
    //cap is lifted (see the Reports box below) and the grid's own box takes the height that is left: the
    //window height minus everything above the grid and everything below it (card padding, the page's
    //bottom padding and the footer). Re-measured by a ResizeObserver - which fires when the pane becomes
    //visible and when the content above the grid (summary chips) or the width changes - and on window resize.
    const [failedDocsTableMaxHeight, setFailedDocsTableMaxHeight] = useState(null);
    const failedDocsTableElRef = useRef(null);
    const failedDocsTableObserverRef = useRef(null);
    const measureFailedDocsTable = useCallback(() => {
        const box = failedDocsTableElRef.current;
        if (!box || box.offsetParent === null) return;   // pane hidden: nothing to measure

        const pageBody = box.closest('.body');                // AdminLayout's area between header and footer
        const footer = document.querySelector('footer.footer');
        if (!pageBody || !footer) return;
        const content = pageBody.lastElementChild || pageBody; // the Container around the routed page
        const px = (el, prop) => parseFloat(window.getComputedStyle(el)[prop]) || 0;

        const boxRect = box.getBoundingClientRect();
        const contentBottom = content.getBoundingClientRect().bottom + px(content, 'marginBottom');
        const below = (contentBottom - boxRect.bottom) + px(pageBody, 'paddingBottom')
            + footer.offsetHeight + px(footer, 'marginTop') + px(footer, 'marginBottom');
        const boxTop = boxRect.top + window.scrollY;

        const next = Math.max(120, Math.floor(window.innerHeight - boxTop - below) - 1);   // floor: ~4 rows on a very short window
        setFailedDocsTableMaxHeight(prev => (prev === next ? prev : next));
    }, []);
    //Callback ref: FailedDocsControls is re-created on every render, so its grid box is a new element
    //each time; keep one observer and move it to whichever element is current.
    const failedDocsTableRef = useCallback(el => {
        if (!failedDocsTableObserverRef.current && typeof ResizeObserver !== 'undefined') {
            //Deferred so the state update is not made inside the observer callback (no "ResizeObserver loop" warning).
            failedDocsTableObserverRef.current = new ResizeObserver(() => window.setTimeout(measureFailedDocsTable, 0));
        }
        const observer = failedDocsTableObserverRef.current;
        if (observer) observer.disconnect();
        failedDocsTableElRef.current = el;
        if (el && observer) {
            observer.observe(el);
            //The card too: when the content above the grid shrinks, the grid only MOVES (its own size is
            //unchanged), but the card's height changes, so this is what catches it.
            const card = el.closest('.card');
            if (card) observer.observe(card);
        }
    }, [measureFailedDocsTable]);
    useEffect(() => {
        window.addEventListener('resize', measureFailedDocsTable);
        return () => {
            window.removeEventListener('resize', measureFailedDocsTable);
            if (failedDocsTableObserverRef.current) failedDocsTableObserverRef.current.disconnect();
        };
    }, [measureFailedDocsTable]);

    function FailedDocsControls({ onGenerate }) {
        //The chip filter only applies while its client is in the loaded window; otherwise show everyone.
        const activeFailedDocsClient = failedDocsData && failedDocsClientFilter !== null
            && (failedDocsData.summary || []).some(s => s.client === failedDocsClientFilter)
            ? failedDocsClientFilter
            : null;
        const visibleFailedDocsRows = !failedDocsData
            ? []
            : activeFailedDocsClient === null
                ? failedDocsData.rows
                : failedDocsData.rows.filter(r => failedDocsClientKey(r) === activeFailedDocsClient);

        return (
            <>
                <Form onSubmit={e => { e.preventDefault(); onGenerate(failedDocsWindow); }}>
                    <Row className="align-items-end g-3">
                        <Col xs={12} md={3}>
                            <Form.Group controlId="failedDocsWindow">
                                <Form.Label>Time Window</Form.Label>
                                <Form.Select
                                    value={failedDocsWindow}
                                    onChange={e => setFailedDocsWindow(e.target.value)}
                                >
                                    {failedDocsWindowOptions.map(w => (
                                        <option key={w.value} value={w.value}>{w.label}</option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>

                        <Col xs={12} md="auto">
                            {/* The picker already drives the grid; this button only downloads the same rows as a workbook. */}
                            {failedDocsDownloadStatus === 'loading' ? (
                                <Button variant="primary" disabled aria-label="Downloading the Failed Docs workbook">
                                    <Spinner
                                        as="span"
                                        animation="grow"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                </Button>
                            ) : (
                                <Button type="submit" variant="primary" title="Download as Excel" aria-label="Download as Excel">
                                    <FontAwesomeIcon icon={faDownload} />
                                </Button>
                            )}
                        </Col>

                    </Row>
                </Form>

                {failedDocsError && (
                    <div style={{ marginTop: '14px', padding: '8px 14px', fontSize: '0.88rem', borderRadius: '6px', background: '#fdecea', color: '#921E1E' }}>
                        {failedDocsError}
                    </div>
                )}

                {/* Nothing failed: say so plainly instead of rendering an empty grid with headers,
                    which reads like the report simply hasn't run. */}
                {failedDocsData && failedDocsData.rows.length === 0 && (
                    <div style={{
                        marginTop: '18px', padding: '32px 20px', textAlign: 'center',
                        background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: '10px'
                    }}>
                        <FontAwesomeIcon icon={faCircleCheck} style={{ width: '34px', height: '34px', color: '#16a34a' }} />
                        <div style={{ marginTop: '10px', fontSize: '1.05rem', fontWeight: 700, color: '#166534' }}>
                            All Docs Healthy
                        </div>
                        <div style={{ marginTop: '4px', fontSize: '0.85rem', color: '#4b5563' }}>
                            No failed documents in {(failedDocsWindowOptions.find(w => w.value === failedDocsData.window)?.label || failedDocsData.window).toLowerCase()}.
                            {failedDocsData.generatedAt ? ' Checked ' + formatRelativeDateTime(failedDocsData.generatedAt) + '.' : ''}
                        </div>
                    </div>
                )}

                {failedDocsData && failedDocsData.rows.length > 0 && (
                    <div style={{ marginTop: '18px' }}>
                        {/* Summary — the same per-client counts as the workbook's Summary sheet. */}
                        <div style={{ display: 'flex', alignItems: 'baseline', gap: '10px', flexWrap: 'wrap', marginBottom: '8px' }}>
                            <span style={{ fontSize: '0.95rem', fontWeight: 700, color: '#1f2937' }}>
                                {activeFailedDocsClient !== null ? `${visibleFailedDocsRows.length} of ` : ''}
                                {failedDocsData.totalCount} failed document{failedDocsData.totalCount === 1 ? '' : 's'}
                            </span>
                            <span style={{ fontSize: '0.82rem', color: '#6b7280' }}>
                                {failedDocsWindowOptions.find(w => w.value === failedDocsData.window)?.label || failedDocsData.window}
                                {failedDocsData.generatedAt ? ' · generated ' + formatRelativeDateTime(failedDocsData.generatedAt) : ''}
                                {failedDocsGridStatus === 'loading' ? ' · updating…' : ''}
                            </span>
                        </div>

                        {/* Client chips double as a filter: click one to show only that client's failures, click it
                            again (or "All") to show everyone. A filter for a client that is not in the loaded window
                            (e.g. after changing the time window) is simply ignored. */}
                        {failedDocsData.summary && failedDocsData.summary.length > 0 && (
                            <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginBottom: '12px' }}>
                                {[{ client: null, label: 'All', count: failedDocsData.totalCount },
                                  ...failedDocsData.summary.map(s => ({ client: s.client, label: s.client, count: s.count }))].map(chip => {
                                    const selected = chip.client === activeFailedDocsClient;
                                    return (
                                        <button
                                            key={chip.client ?? '__all__'}
                                            type="button"
                                            aria-pressed={selected}
                                            title={chip.client === null ? 'Show every client' : (selected ? 'Show every client' : `Show only ${chip.label}`)}
                                            onClick={() => setFailedDocsClientFilter(chip.client === null || selected ? null : chip.client)}
                                            style={{
                                                fontSize: '0.78rem', padding: '2px 10px', borderRadius: '999px', cursor: 'pointer',
                                                background: selected ? '#0d6efd' : '#f3f4f6',
                                                border: selected ? '1px solid #0d6efd' : '1px solid #e5e7eb',
                                                color: selected ? '#ffffff' : '#374151'
                                            }}
                                        >
                                            {chip.label}: <strong>{chip.count}</strong>
                                        </button>
                                    );
                                })}
                            </div>
                        )}

                        <div
                            ref={failedDocsTableRef}
                            style={{ maxHeight: failedDocsTableMaxHeight ? failedDocsTableMaxHeight + 'px' : '55vh', overflowY: 'auto' }}
                        >
                                <Table hover size="sm" style={{ fontSize: '0.82rem', marginBottom: 0 }}>
                                    <thead>
                                        <tr>
                                            <th style={adminStickyThStyle}>Doc Id</th>
                                            <th style={adminStickyThStyle}>File Name</th>
                                            <th style={adminStickyThStyle}>Status</th>
                                            <th style={adminStickyThStyle}>Reason</th>
                                            <th style={adminStickyThStyle}>Failed Stage</th>
                                            <th style={adminStickyThStyle}>Error Message</th>
                                            <th style={adminStickyThStyle}>Client</th>
                                            <th style={adminStickyThStyle}>Created</th>
                                            <th style={adminStickyThStyle}>Status Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {visibleFailedDocsRows.map((r, i) => (
                                            <tr key={r.docId + '-' + i}>
                                                <td>{r.docId}</td>
                                                <td style={{ maxWidth: '280px', wordBreak: 'break-word' }}>{r.fileName}</td>
                                                <td>
                                                    <span style={{
                                                        ...statusLabel,
                                                        fontSize: '0.76rem',
                                                        fontWeight: 600,
                                                        backgroundColor: failedDocsStatusColor(r.status).bg,
                                                        color: failedDocsStatusColor(r.status).fg
                                                    }}>
                                                        {r.status || '—'}
                                                    </span>
                                                </td>
                                                <td style={{ maxWidth: '200px', wordBreak: 'break-word' }}>{failedDocsReasonLabel(r)}</td>
                                                <td style={{ whiteSpace: 'nowrap' }}>{r.failedStage}</td>
                                                <td style={{ maxWidth: '210px', color: '#6b7280' }}>
                                                    {r.errorMessage ? (
                                                        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '6px' }}>
                                                            <Button
                                                                variant="link"
                                                                size="sm"
                                                                title={expandedFailedDocIds.includes(r.docId) ? 'Hide full message' : 'Show full message'}
                                                                style={{ padding: 0, color: '#9ca3af', lineHeight: 1.2, flexShrink: 0 }}
                                                                onClick={() => setExpandedFailedDocIds(prev => prev.includes(r.docId)
                                                                    ? prev.filter(id => id !== r.docId)
                                                                    : [...prev, r.docId])}
                                                            >
                                                                <FontAwesomeIcon icon={expandedFailedDocIds.includes(r.docId) ? faChevronDown : faChevronRight} style={{ width: '10px' }} />
                                                            </Button>
                                                            {/* Collapsed: one clipped line, so a paragraph-long parser error can't set the
                                                                row height. Expanded: the whole message, wrapped. */}
                                                            <span style={expandedFailedDocIds.includes(r.docId)
                                                                ? { wordBreak: 'break-word', whiteSpace: 'pre-wrap' }
                                                                : { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', maxWidth: '195px' }}>
                                                                {r.errorMessage}
                                                            </span>
                                                        </div>
                                                    ) : ''}
                                                </td>
                                                <td style={{ minWidth: '240px', maxWidth: '360px', wordBreak: 'break-word' }}>{r.clientName}</td>
                                                {/* Relative day + time, no seconds; hover shows the full timestamp. Display only - the rows
                                                    keep their full-precision dates, which is what they are ordered by. */}
                                                <td style={{ whiteSpace: 'nowrap' }} title={formatFullDateTime(r.createDate)}>{formatRelativeDateTime(r.createDate)}</td>
                                                <td style={{ whiteSpace: 'nowrap' }} title={formatFullDateTime(r.statusDate)}>{formatRelativeDateTime(r.statusDate)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                    </div>
                )}
            </>
        );
    }

    //Reason shown in the grid, shortened from the API's wording:
    // - "No matching case - Stage 2b propose-only (needs a hand-added case)" -> "No Matching Case".
    // - A parse that failed only because its totals did not reconcile (owner-value total vs check amount,
    //   check summary, invoice total, or Hess / FourPoint property subtotals) arrives as the generic
    //   "Failed (Exception)"; it becomes "Reconcile/OCR Fail" so it reads differently from a crash. Only
    //   that generic label is replaced - the other specific ones (re-queued, stalled) stay as they are.
    //Grid only: the downloaded workbook still shows the API's reason.
    const failedDocsReconcilePattern = /(does not|did not) reconcile|reconciliation FAILED|does not tie to the printed/i;
    function failedDocsReasonLabel(row) {
        const reason = row.reason || '';
        if (reason.startsWith('No matching case')) return 'No Matching Case';
        if (reason === 'Failed (Exception)' && failedDocsReconcilePattern.test(row.errorMessage || '')) {
            return 'Reconcile/OCR Fail';
        }
        return row.reason;
    }

    //The client a row is counted under in the summary chips. The API groups a blank client name as
    //"(unknown)" (string.IsNullOrWhiteSpace), so the filter has to do the same to match its chip.
    function failedDocsClientKey(row) {
        const name = row.clientName;
        return name && name.trim() ? name : '(unknown)';
    }

    //Mirrors the workbook's status pill colors (Excel Bad / Neutral / Info families).
    function failedDocsStatusColor(status) {
        const s = (status || '').toLowerCase();
        if (s === 'exception' || s === 'fail') return { bg: '#E87979', fg: '#921E1E' };
        if (s === 'requested' || s === 'processing') return { bg: '#F2B441', fg: '#7A5A12' };   // stalled
        return { bg: '#e5e7eb', fg: '#4b5563' };
    }

    //Loads the grid. Runs automatically when the Failed Docs pane is opened and whenever the time
    //window changes — there is nothing to decide before showing it, so making you press a button to
    //find out whether anything failed was just a round trip. Reads the SAME API-side query the xlsx is
    //built from, so the grid and a downloaded workbook can never disagree.
    //
    //useCallback so the effect below can depend on it honestly without re-firing every render.
    const failedDocsLoadSeqRef = useRef(0);
    const loadFailedDocsGrid = useCallback(async (timeWindow) => {
        //Numbered so a slower response for an EARLIER window (picker changed quickly) is thrown away
        //instead of overwriting the grid for the window that is now selected.
        const seq = ++failedDocsLoadSeqRef.current;
        const isStale = () => seq !== failedDocsLoadSeqRef.current;
        setFailedDocsGridStatus('loading');
        setFailedDocsError(null);
        try {
            const apiUrl = `a_report/FailedDocsReportData?window=${encodeURIComponent(timeWindow)}`;
            const fetchResponse = await apiGet(apiUrl, getAccessTokenSilently);
            if (isStale()) return;

            if (!fetchResponse || !fetchResponse.ok) {
                setFailedDocsData(null);
                setFailedDocsError(
                    !fetchResponse
                        ? 'Could not reach the API while loading the Failed Docs report.'
                        : `Loading the Failed Docs report failed (HTTP ${fetchResponse.status}).`
                );
                setFailedDocsGridStatus('error');
                return;
            }

            const data = await fetchResponse.json();
            if (isStale()) return;
            setFailedDocsData(data);
            setFailedDocsGridStatus('ready');
        } catch (err) {
            if (isStale()) return;
            setFailedDocsData(null);
            setFailedDocsError('Could not load the Failed Docs report.');
            setFailedDocsGridStatus('error');
            console.error("Error loading Failed Docs Report:", err);
        }
    }, [getAccessTokenSilently]);

    //Load on entering the pane, and again on any window change while it is open. Gated on reportsView
    //so opening the Admin Dashboard doesn't fire this query for someone who never looks at Failed Docs.
    useEffect(() => {
        if (reportsView !== 'faileddocs') return;
        loadFailedDocsGrid(failedDocsWindow);
    }, [reportsView, failedDocsWindow, loadFailedDocsGrid]);

    //Generate keeps its original behavior: build and download the workbook.
    async function handleFailedDocsGenerate(timeWindow) {
        setFailedDocsDownloadStatus('loading');
        try {
            const apiUrl = `a_report/CreateFailedDocsReport?window=${encodeURIComponent(timeWindow)}`;
            const fetchResponse = await apiGet(apiUrl, getAccessTokenSilently);
            const blob = await fetchResponse.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Failed Docs Report (${timeWindow}).xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            setFailedDocsDownloadStatus('ready');
        } catch (err) {
            setFailedDocsDownloadStatus('error');
            console.error("Error exporting Failed Docs Report:", err);
        }
    }

    // Missing API-10 Report state
    const [missingApi10DownloadStatus, setMissingApi10DownloadStatus] = useState('');

    function MissingApi10Controls({ onGenerate }) {
        return (
            <Form onSubmit={e => { e.preventDefault(); onGenerate(); }}>
                <Row className="align-items-end g-3">
                    <Col xs={12} md={2}>
                        {missingApi10DownloadStatus === 'loading' ? (
                            <Button variant="primary" disabled>
                                <Spinner
                                    as="span"
                                    animation="grow"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                            </Button>
                        ) : (
                            <Button type="submit" className="w-100">Generate</Button>
                        )}
                    </Col>
                </Row>
                {missingApi10DownloadStatus === 'error' && (
                    <div className="text-danger small mt-2">The report could not be generated. Please try again.</div>
                )}
            </Form>
        );
    }

    async function handleMissingApi10Generate() {
        setMissingApi10DownloadStatus('loading');
        try {
            const apiUrl = 'a_report/CreateMissingApi10Report';
            const fetchResponse = await apiGet(apiUrl, getAccessTokenSilently);
            if (!fetchResponse || !fetchResponse.ok) {
                throw new Error('Request failed' + (fetchResponse ? ' with status ' + fetchResponse.status : ''));
            }
            const blob = await fetchResponse.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Missing API-10 Report.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            setMissingApi10DownloadStatus('ready');
        } catch (err) {
            setMissingApi10DownloadStatus('error');
            console.error("Error exporting Missing API-10 Report:", err);
        }
    }

    //handle sort link changes for company table
    const handleCompSortChange = async (linkSortBy) => {
        //event.preventDefault();

        console.log('Sort By: ' + linkSortBy);

        let newSortBy = linkSortBy;
        let newSortDirection = 'descending';

        if (sortBy === newSortBy) {
            newSortDirection = sortDirection === 'ascending' ? 'descending' : 'ascending';
        }

        console.log('Sort Direction: ' + sortDirection);

        setSortBy(newSortBy);
        setSortDirection(newSortDirection)

        setDataStatus('loading');
        setCurrentPage(1);

        const currentCriteria = {
            ...dataCriteria,
            skipCount: 0
        };

        await populateCompanies(currentCriteria, newSortBy, newSortDirection)
            .then(response => {
                if (response.data.length === 0) {
                    setDataStatus('nodata')
                }
                else {
                    //console.log('DataFile Count: ' + response.data[0].rowCount);
                    setRowCount(response.data[0].rowCount);
                    setAllCompanies(response.data);
                    setDataStatus('ready')
                    setSelectedAccountId(accountProfile.accountId);
                }
            })
            .catch(ex => {
                setDataStatus('error');
                setDataErrors(ex.message);
            })
            .finally(response => {
                //do something
            })
    }

    //handle sort link changes for user table
    const handleUserSortChange = async (linkSortBy) => {
        //event.preventDefault();

        console.log('Sort By: ' + linkSortBy);

        let newSortUsersBy = linkSortBy;
        let newSortUsersDirection = 'descending';

        if (sortUsersBy === newSortUsersBy) {
            newSortUsersDirection = sortUsersDirection === 'ascending' ? 'descending' : 'ascending';
        }

        console.log('Sort Direction: ' + sortDirection);

        setSortUsersBy(newSortUsersBy);
        setSortUsersDirection(newSortUsersDirection)

        setDataStatus('loading');
        setCurrentPage(1);

        const currentUserCriteria = {
            ...userDataCriteria,
            skipCount: 0
        };

        await populateUsers(currentUserCriteria, newSortUsersBy, newSortUsersDirection)
            .then(response => {
                if (response.data.length === 0) {
                    console.log(response.data);
                    setDataStatus('nodata')
                }
                else {
                    //console.log('DataFile Count: ' + response.data[0].rowCount);
                    setUserRowCount(response.data[0].rowCount);
                    setAllUsers(response.data);
                    setDataStatus('ready')
                    setSelectedAccountId(accountProfile.accountId);
                }
            })
            .catch(ex => {
                setDataStatus('error');
                setDataErrors(ex.message);
            })
            .finally(response => {
                //do something
            })
    }



    return (
        <>
            {/* Instant CSS-only tooltip used by the XLS buttons on the Companies and
                Users tabs. Replaces Bootstrap's OverlayTrigger/Popper tooltips, which
                had a noticeable hover delay and (depending on placement) could cause a
                brief page-level scrollbar flash on first render. Pure :hover, no JS,
                no portal, no layout shift. Wrap a trigger in
                  <span className="dc-inline-tip">
                      {button}
                      <span className="dc-inline-tip-text">label</span>
                  </span>
                and the tooltip appears instantly on hover, anchored to the LEFT of
                the trigger so it doesn't collide with the page edge. */}
            <style>{`
                .dc-inline-tip { position: relative; display: inline-block; }
                .dc-inline-tip > .dc-inline-tip-text {
                    position: absolute;
                    right: calc(100% + 8px);
                    top: 50%;
                    transform: translateY(-50%);
                    background: #1f2937;
                    color: #f9fafb;
                    padding: 4px 8px;
                    border-radius: 4px;
                    font-size: .75rem;
                    line-height: 1.2;
                    white-space: nowrap;
                    pointer-events: none;
                    opacity: 0;
                    visibility: hidden;
                    z-index: 5;
                }
                .dc-inline-tip:hover > .dc-inline-tip-text {
                    opacity: 1;
                    visibility: visible;
                }
            `}</style>
            <p style={{ fontWeight: '500', fontSize: '2rem', margin: '0 0 4px 0', lineHeight: 1.2 }}>
                Admin Dashboard
            </p>
            <div className="body flex-grow-1 px-3">
                <Container fluid>
                    <Row style={{ marginTop: '8px' }}>
                        <Tabs
                            defaultActiveKey="companies"
                            id="admin-dashboard-tabs"
                            className="mb-3"
                            style={{
                                '--bs-nav-link-color': '#000',
                                '--bs-nav-link-hover-color': '#000',
                                '--bs-nav-link-active-color': '#000',  
                                '--bs-nav-link-active-bg': 'transparent'  
                            }}
                        >

                            {/* Companies */}
                            <Tab eventKey="companies" title="Companies">

                                {/*Search Critera*/}
                                <Form onSubmit={submitForm}>
                                    <Row className="justify-content-between">

                                        {/*Company Name*/}
                                        <Col md={3}>
                                            <Form.Group controlId="companyName">
                                                <Form.Label>Search Company</Form.Label>
                                                <InputGroup className="mb-3">
                                                    <FormControl
                                                        name="companyName"
                                                        placeholder="Search by company name..."
                                                        value={dataCriteria.companyName}
                                                        onChange={handleChange}
                                                        onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                                        onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none", border: "1px solid #ced4da" })}
                                                    />
                                                </InputGroup>
                                            </Form.Group>
                                        </Col>

                                        {/*Search Button*/}
                                        <Col xs="auto" className="mb-3 d-flex align-items-end">
                                            {dataStatus === 'loading' ? (
                                                <Button
                                                    disabled
                                                    style={{ ...btnGold }}
                                                >
                                                    <Spinner
                                                        as="span"
                                                        animation="grow"
                                                        size="sm"
                                                        role="status"
                                                        aria-hidden="true"
                                                    />
                                                </Button>
                                            ) : (
                                                <Button
                                                    type="submit"
                                                    disabled={pageStatus !== 'ready'}
                                                    style={
                                                        hoveredBtn && hoveredBtn?.type === 'search'
                                                            ? { ...btnGold, ...btnGoldHover }
                                                            : { ...btnGold }
                                                    }
                                                    onMouseEnter={() => setHoveredBtn({ type: 'search' })}
                                                    onMouseLeave={() => setHoveredBtn(null)}
                                                >
                                                    <FontAwesomeIcon icon={faMagnifyingGlass} />
                                                </Button>
                                            )}
                                        </Col>

                                        {/*Reset Filter Button*/}
                                        <Col xs="auto" className="mb-3 d-flex align-items-end">
                                            {dataStatus === 'loading' ? (
                                                <Button
                                                    disabled
                                                    style={{ ...resetBtnGrey }}
                                                    onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(resetBtnGrey))}
                                                >
                                                    <Spinner
                                                        as="span"
                                                        animation="grow"
                                                        size="sm"
                                                        role="status"
                                                        aria-hidden="true"
                                                    />
                                                </Button>
                                            ) : (
                                                <Button
                                                    style={{ ...resetBtnGrey }}
                                                    type="reset"
                                                    onClick={handleResetCompanyFilters}
                                                    disabled={pageStatus !== 'ready'}
                                                    onMouseEnter={e => Object.assign(e.target.style, boxshadowHover)}
                                                    onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(resetBtnGrey))}
                                                >
                                                    Reset
                                                </Button>
                                            )}
                                        </Col>

                                        {/*XLS Button*/}
                                        <Col xs="auto" className="mb-3 d-flex align-items-end ms-auto">
                                            {downloadDataStatus === 'loading' ? (
                                                <Button variant="primary" style={{ backgroundColor: 'green', borderColor: 'green' }} >
                                                    <Spinner
                                                        as="span"
                                                        animation="grow"
                                                        size="sm"
                                                        role="status"
                                                        aria-hidden="true"
                                                    />
                                                </Button>
                                            ) : (
                                                /* Instant CSS-only tooltip — see <style> block at top of return. */
                                                <span className="dc-inline-tip">
                                                    <Button variant="primary" onClick={handleExportXls} style={{ backgroundColor: 'green', borderColor: 'green' }} >
                                                        <FontAwesomeIcon icon={faFileExcel} />
                                                    </Button>
                                                    <span className="dc-inline-tip-text">Create XLS based on search criteria</span>
                                                </span>
                                            )}
                                        </Col>
                                    </Row>
                                </Form>

                                {/*****************************COMPNAY TABLE*****************************/}
                                <div
                                    ref={scrollContainerRef}
                                    style={{ maxHeight: (screenHeight - 480).toString() + 'px', overflowY: 'auto' }}
                                >
                                    <Table striped style={{ borderRight: "1px solid #dee2e6", borderLeft: "1px solid #dee2e6", borderBottom: "1px solid #dee2e6" }}>
                                        {/*COLUMN TITLES*/}
                                        <thead style={{ fontSize: 14 }}>
                                            <tr>
                                                <th style={{ ...adminStickyThStyle }}></th>
                                                <th className="align-middle p-0 py-3 ps-1" style={{ ...adminStickyThStyle, borderRight: "none" }}></th>
                                                <th className="align-middle p-0 py-3 ps-1" style={{ ...adminStickyThStyle }}>Company Name</th>
                                                <th className="align-middle p-0 py-3 ps-1" style={{ ...adminStickyThStyle }}>Company #</th>

                                                {/*Company Type*/}
                                                <th className="align-middle p-0 py-3" style={{ ...adminStickyThStyle, minWidth: '90px' }}>
                                                    <Form.Group controlId="companyTypeId">
                                                        <Form.Select
                                                            name="companyTypeId"
                                                            disabled={dataStatus === 'loading'}
                                                            value={dataCriteria.companyTypeId === -1 ? '' : dataCriteria.companyTypeId}
                                                            onChange={e => {
                                                                e.target.blur();
                                                                handleCompanyTypeChange(e);
                                                            }}
                                                            className="border-0 fw-bold"
                                                            style={{ backgroundColor: 'transparent', fontSize: 14 }}
                                                            onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                                            onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                                        >
                                                            <option value="" disabled hidden>Type</option>
                                                            <option value="-1">All</option>
                                                            <option value="1">Operator</option>
                                                            <option value="4">Owner</option>
                                                        </Form.Select>
                                                        {dataCriteria.companyTypeId !== -1 && dataCriteria.companyTypeId !== '' && (
                                                            <span style={filterActiveIndicator} title="Filter active" />
                                                        )}
                                                    </Form.Group>
                                                </th>

                                                {/*Member Status*/}
                                                <th className="align-middle p-0 py-3" style={{ ...adminStickyThStyle, minWidth: '150px', maxWidth: '170px' }}>
                                                    <Form.Group controlId="membershipStatus">
                                                        <Form.Select
                                                            name="membershipStatus"
                                                            disabled={dataStatus === 'loading'}
                                                            value={dataCriteria.membershipStatus === -1 ? '' : dataCriteria.membershipStatus}
                                                            onChange={e => {
                                                                e.target.blur();
                                                                handleMemberChange(e);
                                                            }}
                                                            className="border-0 fw-bold"
                                                            style={{ backgroundColor: 'transparent', fontSize: 14 }}
                                                            onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                                            onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                                        >
                                                            <option value="" disabled hidden>Member Status</option>
                                                            <option value="-1">All</option>
                                                            <option value="WILDCATTER">Wildcatter</option>
                                                            <option value="BLACKGOLD - REVENUE">Blackgold - Revenue</option>
                                                            <option value="BLACKGOLD - JIB">Blackgold - JIB</option>
                                                            <option value="OIL BARON">Oil Baron</option>
                                                            <option value="BIG RIG">Big Rig</option>
                                                        </Form.Select>
                                                        {dataCriteria.membershipStatus !== -1 && dataCriteria.membershipStatus !== '' && (
                                                            <span style={filterActiveIndicator} title="Filter active" />
                                                        )}
                                                    </Form.Group>
                                                </th>

                                                {/*Accounting System*/}
                                                <th className="align-middle p-0 py-3" style={{ ...adminStickyThStyle, minWidth: '175px', maxWidth: '1875px' }}>
                                                    <Form.Group controlId="accountingSystem">
                                                        <Form.Select
                                                            name="accountingSystem"
                                                            disabled={dataStatus === 'loading'}
                                                            value={dataCriteria.accountingSystem === "-1" ? '' : dataCriteria.accountingSystem}
                                                            onChange={e => {
                                                                e.target.blur();
                                                                handleAccountingSystemChange(e);
                                                            }                                                            }
                                                            className="border-0 fw-bold"
                                                            style={{ backgroundColor: 'transparent', fontSize: 14 }}
                                                            onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                                            onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                                        >
                                                            <option value="" disabled hidden>Accting System</option>
                                                            <option value="-1">All</option>
                                                            <option value="EnergyLink XML">EnergyLink XML</option>
                                                            <option value="W Energy">W Energy</option>
                                                            <option value="Quorum PDS">Quorum PDS</option>
                                                            <option value="EnergyLink XML v2">EnergyLink XML v2</option>
                                                            <option value="Enertia2">Enertia2</option>

                                                            <option value="IntegraAvatar">IntegraAvatar</option>
                                                            <option value="SAP-Crescent">SAP-Crescent</option>
                                                            <option value="EnergyLinkCsv">EnergyLinkCsv</option>
                                                            <option value="Bolo">Bolo</option>
                                                        </Form.Select>
                                                        {dataCriteria.accountingSystem !== -1 && dataCriteria.accountingSystem !== '' && (
                                                            <span style={filterActiveIndicator} title="Filter active" />
                                                        )}
                                                    </Form.Group>
                                                </th>

                                                {/*JIB Accounting System*/}
                                                <th className="align-middle p-0 py-3" style={{ ...adminStickyThStyle, minWidth: '175px', maxWidth: '1875px' }}>
                                                    <Form.Group controlId="jibAccountingSystemId">
                                                        <Form.Select
                                                            name="jibAccountingSystemId"
                                                            disabled={dataStatus === 'loading'}
                                                            value={dataCriteria.jibAccountingSystemId === -1 ? 0 : dataCriteria.jibAccountingSystemId}
                                                            onChange={e => {
                                                                e.target.blur();
                                                                handleJIBAccountingSystemIdChange(e);
                                                            }                                                            }
                                                            className="border-0 fw-bold"
                                                            style={{ backgroundColor: 'transparent', fontSize: 14 }}
                                                            onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                                            onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                                        >
                                                            <option value={0} disabled hidden>JIB Accting System</option>
                                                            <option value={-1}>All</option>
                                                            <option value={2}>EnergyLink XML</option>
                                                            <option value={3}>W Energy</option>
                                                            <option value={4}>Quorum PDS</option>
                                                            <option value={5}>EnergyLink XML v2</option>
                                                            <option value={6}>Enertia2</option>
                                                            <option value={7}>IntegraAvatar</option>
                                                            <option value={8}>SAP-Crescent</option>
                                                            <option value={9}>EnergyLinkCsv</option>
                                                            <option value={10}>Bolo</option>
                                                        </Form.Select>
                                                        {dataCriteria.jibAccountingSystemId !== -1 && dataCriteria.accountingSystem !== 0 && (
                                                            <span style={filterActiveIndicator} title="Filter active" />
                                                        )}
                                                    </Form.Group>
                                                </th>
                                                {/*<th className="align-middle p-0 py-3 ps-1">Address</th>*/}

                                                <th
                                                    className="align-middle p-0 py-3 ps-1"
                                                    style={{ ...adminStickyThStyle, cursor: "pointer"}}
                                                    onClick={() => handleCompSortChange("LastRevDate")}
                                                >
                                                    Last Rel Date - Rev&nbsp;
                                                    {sortBy === "LastRevDate" ? (sortDirection === "descending"
                                                        ? <FontAwesomeIcon icon={faSortDown} />
                                                        : <FontAwesomeIcon icon={faSortUp} />)
                                                        : <FontAwesomeIcon icon={faSort} />}
                                                    {sortBy === "LastRevDate" && (
                                                        <span style={filterActiveIndicator} title="Filter active" />
                                                    )}
                                                </th>

                                                <th className="align-middle p-0 py-3 ps-1" style={{ ...adminStickyThStyle }}>Last Rel Date - JIB</th>

                                                {/*Doc Conversion Type*/}
                                                <th className="align-middle p-0 py-3" style={{ ...adminStickyThStyle, minWidth: '140px' }}>
                                                    <Form.Group controlId="docConversionNetworkType">
                                                        <Form.Select
                                                            name="docConversionNetworkType"
                                                            disabled={dataStatus === 'loading'}
                                                            value={selectedDocConvOption === "-1" ? '' : selectedDocConvOption}
                                                            onChange={async (e) => {
                                                                e.target.blur();
                                                                setSelectedDocConvOption(e.target.value);
                                                                await handleDocConversionTypeChange(e);
                                                            }}
                                                            className="border-0 fw-bold"
                                                            style={{ backgroundColor: 'transparent', fontSize: 14 }}
                                                            onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                                            onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                                        >
                                                            <option value="" disabled hidden>Doc Conv Type</option>
                                                            <option value= "-1">All</option>
                                                            <option value="1">IMTS</option>
                                                            <option value="3">OGSYS_PCX</option>
                                                            <option value="4">CDEX</option>
                                                            <option value="5">EL_XLS</option>
                                                        </Form.Select>
                                                        {selectedDocConvOption !== "-1" && selectedDocConvOption !== '' && (
                                                            <span style={filterActiveIndicator} title="Filter active" />
                                                        )}
                                                    </Form.Group>
                                                </th>
                                                <th className="align-middle p-0 py-3 ps-1" style={{ ...adminStickyThStyle }}>Internal Id</th>
                                                {/*<th className="align-middle p-0 py-3 ps-1" style={{ ...adminStickyThStyle }}>City</th>*/}
                                                {/*<th className="align-middle p-0 py-3 ps-1" style={{ ...adminStickyThStyle }}>State</th>*/}
                                                {/*<th className="align-middle p-0 py-3 ps-1">Country</th>*/}
                                                {/*<th className="align-middle p-0 py-3 ps-1" style={{ ...adminStickyThStyle }}>Contact Email</th>*/}
                                            </tr>
                                        </thead>
                                        <tbody style={{ fontSize: 14 }}>
                                        {/*COLUMN VALUES*/}
                                            {dataStatus === 'loading' ? (
                                                <LoadingRow colSpan={14} />
                                            ) : allCompanies.length === 0 ? (
                                                <tr>
                                                    <td colSpan="14">No companies to display. Try searching above or resetting your filters.</td>
                                                </tr>
                                            ) : (
                                                allCompanies.map((company, index) => (
                                                    <tr
                                                        key={index}
                                                        onMouseEnter={e => Object.assign(e.currentTarget.style, tableRowHover)}
                                                        onMouseLeave={e => Object.assign(e.currentTarget.style, tableRowUnHover)}
                                                    >
                                                        <td style={{ borderRight: "1px solid #dee2e6"}}>
                                                            {(() => {
                                                                if (company.accountId !== null) {
                                                                    return (
                                                                        <Button
                                                                            variant="outline-primary"
                                                                            size="sm"
                                                                            onClick={() => handleCompanyChange(company.accountId)}
                                                                        >
                                                                            <FontAwesomeIcon icon={faSignInAlt} />
                                                                        </Button>
                                                                    );
                                                                }
                                                            })()}
                                                        </td>
                                                        <td style={{ /*borderRight: "1px solid #dee2e6"*/ }}>
                                                            {(() => {
                                                                if (company.accountId !== null) {
                                                                    return (
                                                                        <Button
                                                                            variant="link"
                                                                            size="sm"
                                                                            disabled={!isAccountSettingsEnabled}
                                                                            style={{
                                                                                padding: 0,
                                                                                color: "black",
                                                                                transition: "transform 0.2s ease, color 0.2s ease"
                                                                            }}
                                                                            onMouseEnter={e => {
                                                                                e.currentTarget.style.transform = "rotate(20deg)";
                                                                                e.currentTarget.style.color = "#555";
                                                                            }}
                                                                            onMouseLeave={e => {
                                                                                e.currentTarget.style.transform = "rotate(0deg)";
                                                                                e.currentTarget.style.color = "black";
                                                                            }}
                                                                            onClick={() => {
                                                                                saveAdminDashState();
                                                                                navigate('/accountsettings', {
                                                                                    state: {
                                                                                        accountId: company.accountId,
                                                                                        companyName: company.companyName
                                                                                    }
                                                                                })
                                                                            }}
                                                                        >
                                                                            <FontAwesomeIcon icon={faGear} />
                                                                        </Button>
                                                                    );
                                                                }
                                                            })()}
                                                        </td>
                                                        <td style={{ borderRight: "1px solid #dee2e6", paddingRight: 0 }}>{company.companyName}</td>
                                                        <td style={{ borderRight: "1px solid #dee2e6", paddingRight: 0 }}>{company.companyCode}</td>
                                                        <td style={{ borderRight: "1px solid #dee2e6", paddingRight: 0 }}>{getCompanyTypeName(company.companyTypeId)}</td>
                                                        <td style={{ borderRight: "1px solid #dee2e6", paddingRight: 0 }}>{company.membershipStatus}</td>
                                                        <td style={{ borderRight: "1px solid #dee2e6", paddingRight: 0 }}>{company.accountingSystem}</td>
                                                        <td style={{ borderRight: "1px solid #dee2e6", paddingRight: 0 }}>{getJIBAccountingSystemIdName(company.jibAccountingSystemId)}</td>
                                                        <td style={{ borderRight: "1px solid #dee2e6", paddingRight: 0 }}>{company.lastSentCheckDate}</td>
                                                        <td style={{ borderRight: "1px solid #dee2e6", paddingRight: 0 }}></td>
                                                        <td style={{ borderRight: "1px solid #dee2e6", paddingRight: 0 }}>
                                                            {
                                                                company.docConversionNetworkTypeId === 1
                                                                    ? getDocConvNetworkTypeName(1)
                                                                    : company.docConversionNetworkTypeId === 2
                                                                        ? (
                                                                            company.docConversionOutputTypeId === -1
                                                                                ? getDocConvNetworkTypeName(2)
                                                                                : getDocConvNetworkTypeName(2)
                                                                                + getDocConvOutputTypeName(company.docConversionOutputTypeId)
                                                                        )
                                                                        : null 
                                                            }
                                                        </td>
                                                        <td style={{ borderRight: "1px solid #dee2e6", paddingRight: 0 }}>{company.id}</td>
                                                        {/*<td style={{ borderRight: "1px solid #dee2e6", paddingRight: 0 }}>{company.city}</td>*/}
                                                        {/*<td style={{ borderRight: "1px solid #dee2e6", paddingRight: 0 }}>{company.state}</td>*/}
                                                        {/*<td>{company.country}</td>*/}
                                                        {/*<td style={{ borderRight: "1px solid #dee2e6", paddingRight: 0 }}>{company.email}</td>*/}
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </Table>
                                </div>

                                {/*Pagination*/}
                                {dataStatus === 'ready' && (
                                    <div className="d-flex justify-content-end">
                                        <PaginationComponent
                                            itemsCount={rowCount}
                                            itemsPerPage={dataCriteria.takeCount}
                                            currentPage={currentPage}
                                            setCurrentPage={setCurrentPage}
                                            pageClickHandler={handlePageClick}
                                            alwaysShown={true}
                                            itemStyle={{ ...paginationStyle, color: "black", }}
                                            activeItemStyle={{ ...activePaginationStyle }}
                                            itemEvents={{
                                                onFocus: e => Object.assign(e.target.style, goldInputFocus),
                                                onBlur: e => Object.assign(e.target.style, { outline: "none", boxShadow: "none", border: "1px solid #ced4da" })
                                            }}
                                        />
                                    </div>
                                )}
                            </Tab>

                            {/* Users */}
                            <Tab eventKey="users" title="Users">

                                {/*Search Critera*/}
                                <Form onSubmit={submitUserForm}>
                                    <Row className="justify-content-between">
                                        {/*User Name*/}
                                        <Col md={3}>
                                            <Form.Group controlId="userName">
                                                <Form.Label>Search User</Form.Label>
                                                <InputGroup className="mb-3">
                                                    <FormControl
                                                        name="firstName"
                                                        placeholder="Search by username or email..."
                                                        value={userDataCriteria.firstName}
                                                        onChange={handleUserChange}
                                                        onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                                        onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none", border: "1px solid #ced4da" })}
                                                    />
                                                </InputGroup>
                                            </Form.Group>
                                        </Col>

                                        {/*Company Name*/}
                                        <Col md={3}>
                                            <Form.Group controlId="companyName">
                                                <Form.Label>Search Company</Form.Label>
                                                <InputGroup className="mb-3">
                                                    <FormControl
                                                        name="companyName"
                                                        placeholder="Search by owner / company name..."
                                                        value={userDataCriteria.companyName}
                                                        onChange={handleUserChange}
                                                        onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                                        onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none", border: "1px solid #ced4da" })}
                                                    />
                                                </InputGroup>
                                            </Form.Group>
                                        </Col>

                                        {/*Search Button*/}
                                        <Col xs="auto" className="mb-3 d-flex align-items-end">
                                            {dataStatus === 'loading' ? (
                                                <Button
                                                    variant="primary"
                                                    disabled
                                                    style={{ ...btnGold }}
                                                >
                                                    <Spinner
                                                        as="span"
                                                        animation="grow"
                                                        size="sm"
                                                        role="status"
                                                        aria-hidden="true"
                                                    />
                                                </Button>
                                            ) : (
                                                <Button
                                                    variant="primary"
                                                    type="submit"
                                                    disabled={pageStatus !== 'ready'}
                                                    style={
                                                        hoveredBtn && hoveredBtn?.type === 'search'
                                                            ? { ...btnGold, ...btnGoldHover }
                                                            : { ...btnGold }
                                                    }
                                                    onMouseEnter={() => setHoveredBtn({ type: 'search' })}
                                                    onMouseLeave={() => setHoveredBtn(null)}
                                                >
                                                    <FontAwesomeIcon icon={faMagnifyingGlass} />
                                                </Button>
                                            )}
                                        </Col>

                                        {/*Reset Filter Button*/}
                                        <Col xs="auto" className="mb-3 d-flex align-items-end">
                                            {dataStatus === 'loading' ? (
                                                <Button
                                                    disabled
                                                    style={{ ...resetBtnGrey }}
                                                    onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(resetBtnGrey))}
                                                >
                                                    <Spinner
                                                        as="span"
                                                        animation="grow"
                                                        size="sm"
                                                        role="status"
                                                        aria-hidden="true"
                                                    />
                                                </Button>
                                            ) : (
                                                <Button
                                                    style={{ ...resetBtnGrey }}
                                                    type="reset"
                                                    onClick={handleResetUserFilters}
                                                    disabled={pageStatus !== 'ready'}
                                                    onMouseEnter={e => Object.assign(e.target.style, boxshadowHover)}
                                                    onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(resetBtnGrey))}
                                                >
                                                    Reset
                                                </Button>

                                            )}
                                        </Col>

                                        {/*Test Button*/}
                                        {/*<Col xs="auto" className="mb-3 d-flex align-items-end">*/}
                                        {/*    <Button*/}
                                        {/*        style={{ ...resetBtnGrey }}*/}
                                        {/*        type="reset"*/}
                                        {/*        onClick={handleTestUserLogin}*/}
                                        {/*        disabled={pageStatus !== 'ready'}*/}
                                        {/*        onMouseEnter={e => Object.assign(e.target.style, boxshadowHover)}*/}
                                        {/*        onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(resetBtnGrey))}*/}
                                        {/*    >*/}
                                        {/*        TEST*/}
                                        {/*    </Button>*/}
                                        {/*</Col>*/}

                                        {/*XLS Button*/}
                                        <Col xs="auto" className="mb-3 d-flex align-items-end ms-auto">
                                            {downloadDataStatus === 'loading' ? (
                                                <Button variant="primary" style={{ backgroundColor: 'green', borderColor: 'green' }} >
                                                    <Spinner
                                                        as="span"
                                                        animation="grow"
                                                        size="sm"
                                                        role="status"
                                                        aria-hidden="true"
                                                    />
                                                </Button>
                                            ) : (
                                                /* Instant CSS-only tooltip — see <style> block at top of return. */
                                                <span className="dc-inline-tip">
                                                    <Button variant="primary" onClick={handleExportUserXls} style={{ backgroundColor: 'green', borderColor: 'green' }} >
                                                        <FontAwesomeIcon icon={faFileExcel} />
                                                    </Button>
                                                    <span className="dc-inline-tip-text">Create XLS based on search criteria</span>
                                                </span>
                                            )}
                                        </Col>
                                    </Row>
                                </Form>

                                {/*Table*/}
                                <div
                                    ref={scrollContainerRef}
                                    style={{ maxHeight: (screenHeight - 480).toString() + 'px', overflowY: 'auto' }}
                                >
                                    <Table striped style={{ borderRight: "1px solid #dee2e6", borderLeft: "1px solid #dee2e6", borderBottom: "1px solid #dee2e6" }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...adminStickyThStyle }}></th>
                                                <th className="align-middle p-0 py-3 ps-1" style={{ ...adminStickyThStyle }}>User Name</th>
                                                <th className="align-middle p-0 py-3 ps-1" style={{ ...adminStickyThStyle }}>User Email</th>
                                                <th className="align-middle p-0 py-3 ps-1" style={{ ...adminStickyThStyle }}>Owner / Company Name</th>
                                                <th className="align-middle p-0 py-3 ps-1" style={{ ...adminStickyThStyle }}>Type</th>
                                                {/*Member Status*/}
                                                <th className="align-middle p-0 py-3" style={{ ...adminStickyThStyle, minWidth: '130px' }}>
                                                    <Form.Group controlId="membershipStatus">
                                                        <Form.Select
                                                            name="membershipStatus"
                                                            disabled={dataStatus === 'loading'}
                                                            value={userDataCriteria.membershipStatus === -1 ? '' : userDataCriteria.membershipStatus}
                                                            onChange={e => {
                                                                e.target.blur();
                                                                handleUserMemberChange(e);
                                                            }}
                                                            className="border-0 fw-bold"
                                                            style={{ backgroundColor: 'transparent' }}
                                                            onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                                            onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                                        >
                                                            <option value="" disabled hidden>Member Status</option>
                                                            <option value="-1">All</option>
                                                            <option value="WILDCATTER">Wildcatter</option>
                                                            <option value="BLACKGOLD - REVENUE">Blackgold - Revenue</option>
                                                            <option value="BLACKGOLD - JIB">Blackgold - JIB</option>
                                                            <option value="OIL BARON">Oil Baron</option>
                                                            <option value="BIG RIG">Big Rig</option>
                                                        </Form.Select>
                                                        {userDataCriteria.membershipStatus !== "-1" && userDataCriteria.membershipStatus !== '' && (
                                                            <span style={filterActiveIndicator} title="Filter active" />
                                                        )}
                                                    </Form.Group>
                                                </th>
                                                <th
                                                    className="align-middle p-0 py-3 ps-1"
                                                    onClick={() => handleUserSortChange("LastLogin")}
                                                    style={{ ...adminStickyThStyle, cursor: "pointer" }}
                                                >
                                                    Last Login&nbsp;
                                                    {sortUsersBy === "LastLogin" ? (sortUsersDirection === "descending"
                                                        ? <FontAwesomeIcon icon={faSortDown} />
                                                        : <FontAwesomeIcon icon={faSortUp} />)
                                                        : <FontAwesomeIcon icon={faSort} />}
                                                    {sortUsersBy === "LastLogin" && (
                                                        <span style={filterActiveIndicator} title="Filter active" />
                                                    )}
                                                </th>
                                                <th className="align-middle p-0 py-3 ps-1" style={{ ...adminStickyThStyle }}>City</th>
                                                <th className="align-middle p-0 py-3 ps-1" style={{ ...adminStickyThStyle }}>State</th>
                                                <th className="align-middle p-0 py-3 ps-1" style={{ ...adminStickyThStyle }}>Country</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {dataStatus === 'loading' ? (
                                                <LoadingRow colSpan={14} />
                                            ) : allUsers.length === 0 ? (
                                                <tr>
                                                    <td colSpan="14">No users to display. Try searching above or resetting your filters.</td>
                                                </tr>
                                            ) : (
                                                allUsers.map((user, index) => (
                                                    <tr
                                                        key={index}
                                                        onMouseEnter={e => Object.assign(e.currentTarget.style, tableRowHover)}
                                                        onMouseLeave={e => Object.assign(e.currentTarget.style, tableRowUnHover)}
                                                    >
                                                        <td style={{ borderRight: "1px solid #dee2e6" }}>
                                                            {(() => {
                                                                if (user.accountId !== null) {
                                                                    return (
                                                                        <Button
                                                                            variant="outline-primary"
                                                                            size="sm"
                                                                            onClick={() => handleCompanyChange(user.accountId)}
                                                                        >
                                                                            <FontAwesomeIcon icon={faSignInAlt} />
                                                                        </Button>
                                                                    );
                                                                }
                                                            })()}
                                                        </td>
                                                        <td style={{ borderRight: "1px solid #dee2e6" }}>{user.firstName + " " + user.lastName}</td>
                                                        <td style={{ borderRight: "1px solid #dee2e6" }}>{user.email}</td>
                                                        <td style={{ borderRight: "1px solid #dee2e6" }}>{user.companyName}</td>
                                                        <td style={{ borderRight: "1px solid #dee2e6" }}>{getCompanyTypeName(user.companyTypeId)}</td>
                                                        <td style={{ borderRight: "1px solid #dee2e6" }}>{user.membershipStatus}</td>
                                                        <td style={{ borderRight: "1px solid #dee2e6" }}>
                                                            {user.lastLogin
                                                                ? new Date(user.lastLogin).toLocaleString(undefined, {
                                                                    year: "numeric",
                                                                    month: "2-digit",
                                                                    day: "2-digit",
                                                                    hour: "2-digit",
                                                                    minute: "2-digit",
                                                                    //second: "2-digit", //taking off seconds
                                                                    hour12: true,
                                                                })
                                                                : ""}
                                                        </td>
                                                        <td style={{ borderRight: "1px solid #dee2e6" }}>{user.city}</td>
                                                        <td style={{ borderRight: "1px solid #dee2e6" }}>{user.state}</td>
                                                        <td style={{ borderRight: "1px solid #dee2e6" }}>{user.country}</td>
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </Table>
                                </div>

                                {/*Pagination*/}
                                {dataStatus === 'ready' && (
                                    <div className="d-flex justify-content-end">
                                        <PaginationComponent
                                            itemsCount={userRowCount}
                                            itemsPerPage={userDataCriteria.takeCount}
                                            currentPage={currentUserPage}
                                            setCurrentPage={setCurrentUserPage}
                                            pageClickHandler={handleUserPageClick}
                                            alwaysShown={true}
                                        />
                                    </div>
                                )}
                            </Tab>

                            {/* Reports */}
                            <Tab eventKey="reports" title="Reports">
                                <Tab.Container activeKey={reportsView} onSelect={key => setReportsView(key || 'inventory')}>
                                    <Row className="g-4">
                                        <Col xs="auto">
                                            <Nav variant="pills" className="flex-row fw-medium gap-2">
                                                <Nav.Item>
                                                    <Nav.Link eventKey="inventory">Inventory</Nav.Link>
                                                </Nav.Item>
                                                <Nav.Item>
                                                    <Nav.Link eventKey="billingnew">Document Billing</Nav.Link>
                                                </Nav.Item>
                                                <Nav.Item>
                                                    <Nav.Link eventKey="docusage">Document Usage</Nav.Link>
                                                </Nav.Item>
                                                <Nav.Item>
                                                    <Nav.Link eventKey="operatorstatus">Operator Status</Nav.Link>
                                                </Nav.Item>
                                                <Nav.Item>
                                                    <Nav.Link eventKey="faileddocs">Failed Docs</Nav.Link>
                                                </Nav.Item>
                                                <Nav.Item>
                                                    <Nav.Link eventKey="missingapi10">Missing API-10</Nav.Link>
                                                </Nav.Item>
                                            </Nav>
                                        </Col>
                                    </Row>
                                    <Row className="g-4">
                                        <div
                                            ref={scrollContainerRef}
                                            style={reportsView === 'faileddocs'
                                                ? undefined   // the Failed Docs grid scrolls itself and fills the page
                                                : { maxHeight: (screenHeight - 480).toString() + 'px', overflowY: 'auto' }}
                                        >
                                            <Card className="shadow-sm rounded-3 border-0">
                                                <Card.Body className="p-4">
                                                    <Tab.Content>
                                                        <Tab.Pane eventKey="inventory">
                                                            <InventoryControls onGenerate={handleInventoryReportGenerate} />
                                                        </Tab.Pane>

                                                        <Tab.Pane eventKey="billing">
                                                            <DocumentBillingControls onGenerate={handleDocumentBillingGenerate} />
                                                        </Tab.Pane>

                                                        <Tab.Pane eventKey="billingnew">
                                                            <DocumentBillingControlsNew onGenerate={handleDocumentBillingGenerateNew} />
                                                        </Tab.Pane>

                                                        <Tab.Pane eventKey="docusage">
                                                            <DocumentUsageControls onGenerate={handleDocumentUsageGenerate} />
                                                        </Tab.Pane>

                                                        <Tab.Pane eventKey="operatorstatus">
                                                            <OperatorStatusControls onGenerate={handleOperatorStatusGenerate} />
                                                        </Tab.Pane>

                                                        <Tab.Pane eventKey="faileddocs">
                                                            <FailedDocsControls onGenerate={handleFailedDocsGenerate} />
                                                        </Tab.Pane>

                                                        <Tab.Pane eventKey="missingapi10">
                                                            <MissingApi10Controls onGenerate={handleMissingApi10Generate} />
                                                        </Tab.Pane>
                                                    </Tab.Content>
                                                </Card.Body>
                                            </Card>
                                        </div>
                                    </Row>
                                </Tab.Container>
                            </Tab>

                            {/* Global Mappings — admin-side editor for global non-operated mappings.
                                Renders inline (no route change): the menu of 2 cards swaps to an
                                embedded CdexCodes_dc / ClassificationCodes_dc when a card is clicked.
                                accountId 69 = TOTData Global Mapping account (Dev). */}
                            <Tab eventKey="docconversion" title="Document Conversion">
                                {globalMappingsView === 'menu' && (
                                    <Container>
                                        <Row className="justify-content-center" style={{ marginTop: '20px', marginBottom: '20px' }}>
                                            <p style={{ fontSize: '1.15rem', fontWeight: '500', color: '#6b7280', margin: 0, textAlign: 'center' }}>
                                                What would you like to configure?
                                            </p>
                                        </Row>
                                        <Row className="justify-content-center" style={{ marginTop: '10px' }}>
                                            <Col xs={12} md={5}>
                                                <Card
                                                    className="mb-3"
                                                    style={{ cursor: 'pointer', background: '#ffffff', border: '1px solid #e5e7eb', borderLeft: '3px solid #5B9BD5', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 2px 10px rgba(0,0,0,.08)', transition: 'transform 150ms ease, box-shadow 150ms ease' }}
                                                    onClick={() => setGlobalMappingsView('cdex')}
                                                    onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,.14)'; }}
                                                    onMouseLeave={e => { e.currentTarget.style.transform = ''; e.currentTarget.style.boxShadow = '0 2px 10px rgba(0,0,0,.08)'; }}
                                                >
                                                    <Card.Header style={{ background: 'transparent', border: 'none', padding: '14px 16px' }}>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
                                                            <div style={{ width: '38px', height: '38px', borderRadius: '9px', background: '#f3f4f6', border: '1px solid #e5e7eb', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                                                <FontAwesomeIcon icon={faLink} style={{ width: '16px', height: '16px', color: '#5B9BD5' }} />
                                                            </div>
                                                            <div style={{ flex: 1, minWidth: 0 }}>
                                                                <div style={{ fontSize: '0.82rem', fontWeight: '800', textTransform: 'uppercase', letterSpacing: '.06em', color: '#1f2937', lineHeight: '1.2' }}>Doc Conv Global Non-Op CDEX Mappings</div>
                                                            </div>
                                                            <FontAwesomeIcon icon={faArrowRight} style={{ width: '13px', color: '#9ca3af', flexShrink: 0 }} />
                                                        </div>
                                                    </Card.Header>
                                                </Card>
                                            </Col>
                                            {/* JIB Classification Mappings card temporarily removed — restore by uncommenting this block.
                                            <Col xs={0} className="d-none d-md-block" style={{ flex: '0 0 2.08%', maxWidth: '2.08%' }} />
                                            <Col xs={12} md={5}>
                                                <Card
                                                    className="mb-3"
                                                    style={{ cursor: 'pointer', background: '#ffffff', border: '1px solid #e5e7eb', borderLeft: '3px solid #5B9BD5', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 2px 10px rgba(0,0,0,.08)', transition: 'transform 150ms ease, box-shadow 150ms ease' }}
                                                    onClick={() => setGlobalMappingsView('jib')}
                                                    onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,.14)'; }}
                                                    onMouseLeave={e => { e.currentTarget.style.transform = ''; e.currentTarget.style.boxShadow = '0 2px 10px rgba(0,0,0,.08)'; }}
                                                >
                                                    <Card.Header style={{ background: 'transparent', border: 'none', padding: '14px 16px' }}>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
                                                            <div style={{ width: '38px', height: '38px', borderRadius: '9px', background: '#f3f4f6', border: '1px solid #e5e7eb', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                                                <FontAwesomeIcon icon={faSliders} style={{ width: '16px', height: '16px', color: '#5B9BD5' }} />
                                                            </div>
                                                            <div style={{ flex: 1, minWidth: 0 }}>
                                                                <div style={{ fontSize: '0.82rem', fontWeight: '800', textTransform: 'uppercase', letterSpacing: '.06em', color: '#1f2937', lineHeight: '1.2' }}>JIB Classification Mappings</div>
                                                            </div>
                                                            <FontAwesomeIcon icon={faArrowRight} style={{ width: '13px', color: '#9ca3af', flexShrink: 0 }} />
                                                        </div>
                                                    </Card.Header>
                                                </Card>
                                            </Col>
                                            */}
                                        </Row>
                                    </Container>
                                )}
                                {globalMappingsView !== 'menu' && (
                                    <div>
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '-4px', marginBottom: '4px' }}>
                                            <span
                                                style={{ ...backBtn }}
                                                onClick={() => setGlobalMappingsView('menu')}
                                            >
                                                <FontAwesomeIcon icon={faArrowLeft} />
                                            </span>
                                            <span style={{ fontSize: '1rem', fontWeight: 700, color: '#333333' }}>
                                                {globalMappingsView === 'cdex' ? 'Doc Conv Global Non-Op CDEX Mappings' : 'JIB Classification Mappings'}
                                            </span>
                                            <span style={{ width: '40px' }} />{/* spacer to keep title centered against the back arrow */}
                                        </div>
                                        {globalMappingsView === 'cdex' && globalAccountId && <CdexCodes_dc accountId={globalAccountId} embedded={true} />}
                                        {globalMappingsView === 'cdex' && !globalAccountId && (
                                            <div style={{ display: 'flex', justifyContent: 'center', padding: '40px 0' }}>
                                                <Spinner animation="border" style={{ color: COLORS.gold }} />
                                            </div>
                                        )}
                                        {globalMappingsView === 'jib' && globalAccountId && <ClassificationCodes_dc accountId={globalAccountId} embedded={true} />}
                                    </div>
                                )}
                            </Tab>

                            {/* Regression Tests — launch and monitor the hosted Document Conversion
                                regression suite. Replaces the manual RUN_RegressionTests.sql workflow
                                (flip IsActive -> insert a Process 14 row -> drop a queue refresh message
                                -> poll TestRun/TestItem in SQL).

                                mountOnEnter/unmountOnExit (Tabs renders every pane eagerly by default):
                                without them this tab would fire its three API calls on every Admin
                                Dashboard load, and its 4s poll would keep running while you were on
                                another tab. Per-Tab values win over the parent Tabs defaults. */}
                            <Tab eventKey="regressiontests" title="Regression Tests" mountOnEnter unmountOnExit>
                                {/* No maxHeight/overflow wrapper here: the component gives its two
                                    tables their own scroll regions, and clipping them inside a second
                                    scroller as well produced nested scrollbars and a short viewport. */}
                                <RegressionTests />
                            </Tab>
                        </Tabs>
                    </Row>
                </Container>
            </div>
        </>
    );

};

export default AdminDashboard;